define('apps/admin/views/layout',[
    'app',
    'moment',
    'i18next',
    'vue',
    'common/behaviors/actions',
    'common/components/comet/behaviors/comet-dropdown',
    'common/components/inactivity-modal/behaviors/inactivity',
    'common/components/vue-wrapper/helpers/mount-vue-component',
    'common/components/product-bar/views/product-bar',
    'njs!common/components/edde/templates/nav/includes/footer/_footer_cobranding_new(params:tmpl=edde/nav/includes/footer/_footer_cobranding_new.html)',
    'njs!apps/admin/templates/includes/_school_select(params:tmpl=admin/main/includes/_school_select.html)',
    'njs!apps/classrooms/templates/qr-code/includes/_feedback_messages',
    'apps/admin/views/modals/archive_unarchive_modal',
    'apps/admin/views/modals/archive_user_confirm',
    'apps/admin/views/modals/unarchive_user_confirm',
    'apps/admin/views/modals/archive_class_confirm',
    'apps/admin/views/modals/unarchive_class_confirm',
    'apps/admin/views/modals/duplicate_class_confirm',
    'apps/admin/views/modals/reset_password',
    'apps/admin/views/modals/add-product',
    'apps/admin/views/modals/bulk-import-upload-modal',
    'apps/admin/views/modals/bulk-import-download-modal',
    'apps/admin/views/modals/onboarding-start-over-modal',
    'apps/admin/views/modals/promo-modal',
    'apps/admin/views/modals/upload-promo-image',
    'apps/admin/views/modals/send-domain-verification-code-modal',
    'apps/admin/views/modals/leave-service-data-details-form-modal',
    'apps/admin/views/license-products',
    'apps/admin/views/validation-message',
    'apps/admin/views/strong-validation',
    'apps/admin/views/block-message',
    'apps/admin/views/audience-guid',
    'apps/classrooms/views/modals/bulk_set_qr_generate',
    'apps/classrooms/views/modals/bulk_set_qr_block_message',
    'apps/admin/views/components/admin-toast-message',
    'apps/admin/views/components/clever-id-mapping-dropdown',
    '@discoveryedu/nebula-components',
    '@discoveryedu/platform-components',
    '@discoveryedu/platform-pages/AssetManagementTool',
    '@discoveryedu/platform-pages/GlobalLicenseQueue'
    ], function (
        app,
        moment,
        i18next,
        Vue,
        ActionsBehavior,
        CometDropDownBehavior,
        InactivityBehavior,
        mountVueComponent,
        ProductBar,
        footerCobrandingTemplate,
        schoolSelect,
        feedBackMessage,
        ArchiveUnarchiveModal,
        ArchiveUserConfirmModal,
        UnArchiveUserConfirmModal,
        ArchiveClassConfirmModal,
        UnarchiveClassConfirmModal,
        DuplicateClassConfirmModal,
        ResetPasswordModal,
        AddProductModal,
        BulkImportUploadModal,
        BulkImportDownloadModal,
        OnboardingStartOverModal,
        PromoModal,
        UploadPromoImageModal,
        SendDomainVerificationCodeModal,
        LeaveServiceDataDetailsFormModal,
        LicenseProducts,
        ValidationMessage,
        StrongValidation,
        BlockMessage,
        AudienceGuid,
        BulkSetQRModalGenerate,
        BulkSetQrMessage,
        AdminToastMessage,
        CleverIDMappingDropdown,
        NebulaComponents,
        PlatformComponents,
        AssetManagementTool,
        GlobalLicenseQueue
    ) {
    'use strict';

    return Mn.LayoutView.extend({

        "el": $(".comet-page-shell").length > 0 ? ".comet-page-shell" : "#scroll-content",

        "template": false,

        "regions": {
            "content": "#admin-content",
            "productBar": ".comet-product-bar-container"
        },

        "behaviors": {
            "Actions": {
                "behaviorClass": ActionsBehavior
            },
            "CometDropDown": {
                "behaviorClass": CometDropDownBehavior
            },
            "InactivityBehavior": {
                "behaviorClass": InactivityBehavior
            }
        },

        "events": {
            "click #preview": "onClickPreview",
            "click .admin-privacy-top-hat__close-button": "dismissPrivacyNotice",

            "click .js-admin-trigger-back": "navigateBack",
            "click .js-admin-move-select-options": "moveSelectOptions",
            "click [data-modal-trigger]": "onClickModalTrigger",
            "click [data-trigger-reload]": "onClickTriggerReload",
            "click [data-copy-to-clipboard]": "onClickCopyToClipboard",
            "change [data-datepicker-trigger-mindate-target]": "onChangeDatepickerTriggerMindate",
            "change [data-select-comet-tab-panel]": "selectCometTabPanel",
            "click .table-action-menu__action-unassign--all": "unassignAllModal",
            "click .quick-action--archive-account": "onClickArchiveUnarchiveQuickAction",
            "click .quick-action--unarchive-account": "onClickArchiveUnarchiveQuickAction",
            "click .quick-action--archive-site": "onClickArchiveUnarchiveQuickAction",
            "click .quick-action--unarchive-site": "onClickArchiveUnarchiveQuickAction",
            "click .quick-action--archive-user": "archiveUserModal",
            "click .quick-action--unarchive-user": "unarchiveUserModal",
            "click .quick-action--archive-class": "archiveClassModal",
            "click .quick-action--unarchive-class": "unarchiveClassModal",
            "click .quick-action--duplicate-class": "duplicateClassModal",
            "click .quick-action--reset-password": "onClickQuickActionResetPassword",
            "change [data-update-schools-on-change]": "onDistrictChange",
            "change [data-toggle-element]": "toggleElement",
            "change .admin-form--browse-users select#district": "onBrowseUsersAndClassroomsDistrictChange",
            "change .admin-form--browse-classrooms select#district": "onBrowseUsersAndClassroomsDistrictChange",
            "keyup .admin-form--user-district-associations #district-input": "getUserDistrictAssociationsDistricts",
            "change [data-update-regions-on-change]": "onCountryChange",
            "click .admin-form--create-licenses #add-product": "addProductModal",
            "change input[name='internal-admin-forms__toggle']": "toggleInternalAdminForms",
            "click .comet-tab__label": "selectCometLabel",
            "change .admin-form--user-school-associations input[name='primary']": "selectAccessCheckbox",
            "keyup [data-simple-api-validate]": "onSimpleApiValidatedKeyup",
            "keyup .admin-form--user #email": "onEmailKeyUp",
            "keyup .admin-form--user #username": "onUsernameKeyup",
            "blur .admin-form--user #username": "onUsernameKeyup",
            "input .admin-form--user #password": "onPasswordInput",
            "input .admin-form--user #password-confirm": "validatePasswordConfirm",
            "keyup [data-validate-json]": "onValidateJSONKeyup",
            "submit [data-validate-form]": "onFormSubmit",
            "change [data-post-on-change]": "postFormOnSelectChange",
            "change .admin-form--add-account select#entity-type": "onChangeEntityType",
            "change .admin-form--add-site select#entity-type": "onChangeEntityType",
            "change .admin-form--edit-site select#entity-type": "onChangeEntityType",
            "change .admin-form--add-class-site-select [name='site_guid']": "submitTargetForm",
            "change .admin-form--user-transfer-get-source [name='source_site_guid']": "submitTargetForm",
            "change .admin-form--user-transfer-get-target [name='target_site_guid']": "submitTargetForm",
            "mousedown .select2-container ~ .comet-form__select-open-indicator": "toggleSelect2",
            "click #check-all": "checkAll",
            "click .check-all": "checkAll",
            "click #uncheck-all": "uncheckAll",
            "click .uncheck-all": "uncheckAll",
            "click .admin-form__button-container #add-class-save": "onClickAddClassSave",
            "change .admin-form--licensing #start_date": "setLicenseEndDate",
            "change .admin-form--licensing #duration": "onChangeLicenseDuration",
            "change .admin-form--view-licenses input": "disableLicenseUpdate",
            "click #admin-form--csv-translator #format-json": "formatCSVTranslatorJSON",
            "select2:select #admin-form--edit-school-ids .school_ids": "onChangeSchoolIds",
            "select2:unselect #admin-form--edit-school-ids .school_ids": "onChangeSchoolIds",
            "click #promo-form-edit": "updatePromo",
            "click #promo-form-create": "createPromo",
            "click #promo-form-upload-image": "openPromoUploadModal",
            "click #change-asset": "getAssetGuidData",
            "click #archive-promo": "archivePromo",
            "change input[type='radio'][name='promo-bg-color']": "onTogglePromoGradient",
            "change input[type='radio'][name='promo-bg-gradient']": "onSelectPromoGradient",
            "change #highlight_type": "updatePromoFormControls",
            "change #promo-bg-custom": "updatePromoFormControls",
            "change #admin-form--edit-campaign #campaign-country": "getCampaignParentProducts",
            "change #admin-form--create-campaign #campaign-country": "getCampaignParentProducts",
            "change #admin-form--edit-campaign #parent-product": "findCampaignProductSKUs",
            "change #admin-form--create-campaign #parent-product": "findCampaignProductSKUs",
            "click #process-now": "executeGUPMapping",
            "click #add-account-guid": "addAccountGuid",
            "click #add-site-guid": "addSiteGuid",
            "keydown #account-guid": "disableBtnOnInvalidGuid",
            "keydown #site-guid": "disableBtnOnInvalidGuid",
            "mousedown table.resizable .column-resizer": "resizeTableColumns",
            "touchstart table.resizable .column-resizer": "resizeTableColumns",
            "change .admin-form [name=selected_role]": "onSelectedRoleChange",

            "click #bulk_qr_generate": "generateQRCodes",
            "click .qr-select-action__selection": "handleSelectStudents",
            "change #check-student-indicator": "toggleCheckAll",
            "click .clear-selection": "handleSelectNone",
            "change .students-qr-table-body .comet-form__checkbox-input": "setBulkSelectionMode",
            "click .qr-back-btn": "confirmToExitQr",
            "click .qr-code__content .clear-selection": "clearSelection",
            "keyup #verification-code": "displayAddDomainBtn",
            "click #idSearch": "searchById",
            "click #termSearch": "searchElastic",
            "keyup #term": "submitSearchElastic",

            //Onboarding
            "change .onboard-select-sso__input": "enableSelectSSOContinueButton",
            "click .onboard-select-sso__continue": "handleOnboardSelectSSOFormSubmit",
            "click .onboarding-methods__method": "enableContinueButton",
            "click .onboarding-methods__footer .nebula-button": "submitSelectedMethod",
            "change .onboarding-clever input[name=email_use]": "toggleCleverPopulateAccount",
            "click .onboarding-clever__continue": "submitCleverSSOConfig",
            "change .onboarding-classlink input[name=email_use]": "enableClasslinkContinueButton",
            "keyup .onboarding-classlink input[name=tenant_id]": "enableClasslinkContinueButton",
            "click .service-details__footer .nebula-button": "submitServiceDetails",
            "keyup #service-details-form .comet-form__input": "enableContinueToMapSchoolButton",
            "change .admin-onboarding-map-schools__unmapped .comet-form__select-input": "onCleverSchoolSelected",
            "click .admin-onboarding__footer--map-clever .onboarding-footer__button-container .nebula-button--square": "submitCleverSchools",
            "click .add-subdomain__submit": "validateSubdomainEntry",
            "click .admin-onboarding__block-message-close": "closeBlockMessage",
            "click .js-pagination-exclusions": "listExclusions",
            "click .js-pagination": "searchElastic",

            // Ldap certificate check
            "click .check-server-button": "onClickCheckServerButton",
            "click #check-all-servers-button": "onClickCheckAllServersButton",

            // 2022 School ID Mapping
            "click": "toggleAllSelectDropdownState",
            "click .school-dropdown-item__button": "postSelectedSchoolForMatching",
            "change #admin-pages-select": "updatePagination",

            // Product Licenses page
            //  routes:
            //      '/sites/<site_guid>/licenses'
            "click .admin-search-results-parts__btn--parts": "toggleProductDisplayNameDropdown",
            "click .subpart-table__btn--guid": "productPartGuidCopy",
        },

        "unarchiveUserXHR": null,
        "archiveUserXHR": null,
        "validateEmailXHR": null,
        "validateUsernameXHR": null,
        "validatePasswordXHR": null,
        "validateEmailAddressXHR": null,
        "validateSlxidXHR": null,
        "validatePidXHR": null,
        "validateSfidXHR": null,
        "validateStudent_idXHR": null,
        "validateTeacher_idXHR": null,
        "validateImplementationleademailXHR": null,
        "validateProfessionaldevelopmentleademailXHR": null,
        "validateTechnicalleademailXHR": null,
        "validateApi_endpointXHR": null,
        "userDistrictPrefixSearch": null,
        "updateSchoolIdsXHR": null,
        "searchContainer": $('.comet-row.admin-row[data-action-url]'),

        "selectedQrStudents": [],
        "isBulkSelection": false,
        "strongValidationConfig": {
            'doesnt_have_min_characters': true,
            'contains_username': true,
            'contains_first_name': true,
            'contains_last_name': true,
            'contains_repeat_characters': true,
            'missing_upper_lower': true,
            'contains_common_passwords': true,
        },
        "featureFlags": app.initData.get('feature_flags') || {},

        "initialize": function() {
            this.listExclusions();
            this.privacyNoticeDismissed = sessionStorage.getItem('admin-privacy-notice-dismissed') === "true";

            this.initializeAllSelect2();
            this.initializeAllDatePickers();
            this.initializeAccountImportData();
            this.initializeAccountSelect();
            this.initializeSiteSelect();
            this.initializeAssignedAccountsSelect();
            this.initializeEligibleTeachersSelect();
            this.initializeLicenseDatePickers();
            this.initializeLicenseProductsView();
            if ($('#user-school-associations').length) {
                this.selectAccessCheckbox();
            }
            if ($('#admin-form--create-campaign').length || $('#admin-form--edit-campaign').length) {
                this.getCampaignParentProducts();
            }
            this.getRegion('productBar').attachView(new ProductBar());
            this.getRegion('productBar').currentView.onRender();
            this.initializePromo();
            this.initResizableTables();
            if ($('.admin-onboarding__block-message-container').length) {
                this.showOnboardingBlockMessage();
            }

            if ($('#clever-id-pagination').length && initData.pagination.total_pages > 1) {
                this.initializeCleverIdMappingPagination();
            }

            if ($('#edit_promo').length || $('#create_promo').length) {
                this.initializePromoPage();
            }

            if ($('#banner-preview-container').length) {
                this.initializePreview();
            }

            if ($('#manage-users-refresh').length) {
                this.initializeManageUsersRefresh();
            }

            if ($('#admin-asset-exclusions-app').length) {
                this.mountAssetExclusions();
            }

            if ($('#admin-glq-app').length) {
                this.mountGLQ();
            }

            AdminToastMessage.renderToastMessage();

            this.model = new Backbone.Model({
                "is_sso": false,
            });

            if (this.featureFlags['strong-passwords-teacheradmins']) {
                this.strongValidationView = new StrongValidation({
                    'model': new Backbone.Model({
                        'target': 'strong-validation__section--rules',
                        'validationConfig': this.strongValidationConfig,
                        'is_valid': false
                    })
                });

                $('.strong-validation__section--rules').append(this.strongValidationView.render().$el);
            }

        },

        "cleanGuidData": function () {
            var input = $("#ids").val().toLowerCase();

            var guids = input
                    .split(/[^0-9A-F-]+/i)
                    .filter(function(guid) {
                            return /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i.test(guid);
                    });
            var cleanGuids = new Set(guids);

            return Array.from(cleanGuids);
        },

        "searchById": function () {
            var formUrl = this.searchContainer.data("actionUrl");
            var token = this.searchContainer.data("exclusionSearchToken");
            var assetIds = this.cleanGuidData();

            if (assetIds.length) {
                // select the search tab
                $("#search-results-tab").click();
                $("#comet-tab-panel-id--search-results").checked;

                $('#exclusionsSearchResults').html("<p>Searching... Please wait.</p>");

                $.ajax({
                    "url": formUrl,
                    "type": "POST",
                    "data": {'asset_ids': assetIds },
                    "headers": { 'X-Token': token },
                    "success": function (response) {
                        $('#exclusionsSearchResults').html(response);
                    },
                    "fail": function () {
                        $('#exclusionsSearchResults').html("<p>An error occurred. Please contact support</p>");
                    }
                });
            }
        },

        "listExclusions": function (event) {
            if (!$('#idSearch').length && !$('#termSearch').length) {
                return false;
            }

            var formUrl = $('.comet-row.admin-row[data-list-url]').attr('data-list-url');

            if (event) {
                if ($(event.target).data('pageno')) {
                    formUrl += "?page=" + $(event.target).data('pageno');
                }
            }

            $('#exclusionsList').html("<p>Fetching... Please wait.</p>");

            $.ajax({
                "url": formUrl,
                "type": "GET",
                "success": function (response) {
                    $('#exclusionsList').html(response);
                },
                "fail": function () {
                    $('#exclusionsList').html("<p>An error occurred. Please contact support</p>");
                }
            });
        },

        "submitSearchElastic": function (event) {
            if (event.keyCode === 13) {
              this.searchElastic();
              return false;
            }
        },

        "searchElastic": function (event) {
            var formUrl = this.searchContainer.data("actionUrl");

            var formFieldsSerialized = $("#asset-exclusion").serialize();
            var fullFormUrl = formUrl + '?' + formFieldsSerialized;

            if (event) {
                if ($(event.target).data('pageno')) {
                    fullFormUrl += "&page=" + $(event.target).data('pageno');
                }
            }

            // select the search tab
            $("#search-results-tab").click();
            $("#comet-tab-panel-id--search-results").checked;

            $('#exclusionsSearchResults').html("<p>Searching... Please wait.</p>");

            $.ajax({
                "url": fullFormUrl,
                "type": "GET",
                "success": function (response) {
                    $('#exclusionsSearchResults').html(response);
                },
                "fail": function () {
                    $('#exclusionsSearchResults').html("<p>An error occurred. Please contact support</p>");
                }
            });
        },

        "initResizableTables": function () {
            var resizableTables = this.$('table.resizable');
            _.each(resizableTables, function ($table) {
                this.initResizableTable($table);
            }, this);
        },

        "initResizableTable": function (table) {
            var $table = this.$(table);
            var row = $table.find('tr')[0];
            var cols = row ? row.children : null;

            if (!cols) { return; };

            $table.find('.comet-data-table__header').css('overflow', 'visible');

            var tableHeight = $table.outerHeight();

            _.each(cols, function (col) {
                var columnResizerDiv = $('<div>').addClass('column-resizer').css({ 'height': tableHeight + 'px' });
                this.$(col).append(columnResizerDiv).css('position', 'relative');
            }, this);
        },

        "onRender": function () {
            var $studentsQRTable = $('.students-qr-table');

            if ($studentsQRTable && $studentsQRTable.length > 0) {
                var isAdmin = $('.qr-code__content').data('isAdmin') === 'True';

                this.model = new Backbone.Model({
                    "student": $studentsQRTable.data('student'),
                    "students": $studentsQRTable.data('students'),
                    "classroom": $studentsQRTable.data('classroom'),
                    "site": $studentsQRTable.data('site'),
                    "account": $studentsQRTable.data('account'),
                    "isAdmin": isAdmin,
                    "searchTeachersToken": app.initData.get("tokens").search_teachers,
                });

                // override background for just the new bulk qr manager.
                $('#comet-page-shell__product-well').addClass('bulk-qr-manager');
            }

            if ($('.admin-onboarding').length > 0) {
                $('.comet-page-shell.admin-page-shell')
                    .addClass('account-onboarding');
            }
        },

        "onClickCheckAllServersButton": function(e) {
            var ldapServers = app.initData.get('ldap_servers');

            _.each(ldapServers, function(ldapServer) {
                $('#check-server-button-' + ldapServer.id).click();
            });
        },

        "onClickCheckServerButton": function(e) {
            var ldap_server_id = $(e.currentTarget).data('ldap-server-id');

            $('#server-results-' + ldap_server_id).html('Pending...');
            $('#check-server-button-' + ldap_server_id).addClass('comet-button--disabled');
            $('#check-server-button-' + ldap_server_id).prop('disabled', true);

            $.ajax({
                "url": '/ldap/check-connection/' + ldap_server_id,
                "type": 'GET'
            }).done(function(data) {
                $('#server-results-' + ldap_server_id).html(data.message);
            }).fail(function(jqXHR, textStatus, errorThrown) {
                $('#server-results-' + ldap_server_id).html('Could not test server.');
            }).always(function() {
                $('#check-server-button-' + ldap_server_id).removeClass('comet-button--disabled');
                $('#check-server-button-' + ldap_server_id).prop('disabled', false);
            });
        },

        "resizeTableColumns": function (e) {
            var eventType = e.type.toLowerCase(); // 'mousedown' or 'touchstart'
            var $table = this.$(e.currentTarget).closest('table');

            var pageX;
            var curCol;
            var nxtCol;
            var curColWidth;
            var nxtColWidth;

            // disable text selection during events to prevent the entire table from showing selection highlight (issue with Safari); resets this property below on mouseup
            $table.css('-webkit-user-select', 'none');

            function paddingDiff(col) {
                if ($(col).css('box-sizing') === 'border-box') {
                    return 0;
                }
                var padLeft = $(col).css('padding-left');
                var padRight = $(col).css('padding-right');
                return parseInt(padLeft, 10) + parseInt(padRight, 10);
            }

            curCol = e.target.parentElement;
            nxtCol = curCol.nextElementSibling;
            var pageX = eventType === 'mousedown' ? e.pageX : e.originalEvent.touches[0].pageX;

            var padding = paddingDiff(curCol);

            curColWidth = curCol.offsetWidth - padding;
            if (nxtCol) {
                nxtColWidth = nxtCol.offsetWidth - padding;
            }

            var mousemoveEvent = function (evt) {
                if (curCol) {
                    var diffX = evt.pageX - pageX,
                        cColWidth = curColWidth + diffX,
                        nColWidth = nxtColWidth - diffX;
                    if (nxtCol) {
                        $(nxtCol).css('width', nColWidth + 'px');
                    }
                    $(curCol).css('width', cColWidth + 'px');
                }
            };

            var touchmoveEvent = function (evt) {
                if (curCol) {
                    var diffX = evt.originalEvent.touches[0].pageX - pageX,
                        cColWidth = curColWidth + diffX,
                        nColWidth = nxtColWidth - diffX;
                    if (nxtCol) {
                        $(nxtCol).css('width', nColWidth + 'px');
                    }
                    $(curCol).css('width', cColWidth + 'px');
                }
            };

            if (eventType === 'mousedown') {
                $(document).on('mousemove', mousemoveEvent);
            }

            if (eventType === 'touchstart') {
                $(document).on('touchmove', touchmoveEvent);
            }

            $(document).on('mouseup', function () {
                curCol = null;
                nxtCol = null;
                pageX = null;
                nxtColWidth = null;
                curColWidth = null;

                $table.css('-webkit-user-select', '');

                $(document).off('mousemove', mousemoveEvent);
                $(document).off('touchmove', touchmoveEvent);
            });
        },

        "onSelectedRoleChange": function(e){
            var $currentTarget = this.$(e.currentTarget);
            var $container = $currentTarget.closest('.admin-form-container');

            var blockMessages = $container.find(".block-message-container");
            var userForm = $container.find("#admin-form--user");
            var spinner = $container.find("#reload-spinner");

            blockMessages.remove();
            userForm.remove();
            spinner.show();
        },

        "getCampaignParentProducts": function(e){
            if (e) {
                // clear product inputs
                this.populateSelectInput('available-products', [], true);
                this.populateSelectInput('products', [], true);
            }

            var apiUrl = '/apiproxy/v1/products/find';
            var countryCode = this.$('#campaign-country').val();
            var ajaxOptions = {
                'context': this,
                'data': {
                    'status_id': 1,
                    'country_code': countryCode
                },
                'url': apiUrl,
                'xhrFields': {
                    'withCredentials': true
                  }
            };

            $.ajax(ajaxOptions).done(function(data){
                var selectedProductGuid = app.initData.get('product_guid');
                var productOptions = _.map(data.products, function(product){
                    return { 'name': product.name, 'value': product.id, 'selected': product.id === selectedProductGuid };
                });
                productOptions.unshift({'name': 'Select a Product'});
                this.populateSelectInput('parent-product', productOptions, true);
            });
        },

        "findCampaignProductSKUs": function(e){
            var parentProductGuid = this.$('#parent-product').val();

            if (parentProductGuid) {

                var ajaxOptions = {
                    'context': this,
                    'data': {
                        'product_id': parentProductGuid,
                    },
                    'url': '/apiproxy/v1/products/find/sku',
                    'xhrFields': {
                        'withCredentials': true
                      },
                    'traditional': true
                };

                $.ajax(ajaxOptions).done(function(data){
                    var productOptions = _.map(data.products, function(product){ return {'name': product.name, 'value': product.id }; });
                    if (productOptions.length) {
                        this.populateSelectInput('available-products', productOptions, true);
                    } else {
                        this.populateSelectInput('available-products', [{'name': 'No Product SKUs found'}], true);
                    }
                });
            }
        },

        "onClickArchiveUnarchiveQuickAction": function(e){
            e.preventDefault();

            var quickActionCode = $(e.currentTarget).data('quick-action-code');
            var formAction = $(e.currentTarget).data('form-action');
            var formToken = app.initData.get(quickActionCode.replace(/-/g, "_") + '_form_token');

            var modalContent = {
                'archive-account': {
                    'modalHeader': 'Archive District?',
                    'modalText': 'Are you sure you want to archive district?',
                    'modalButtonText': 'Archive District'
                },
                'unarchive-account': {
                    'modalHeader': 'Unarchive District?',
                    'modalText': 'Are you sure you want to unarchive district?',
                    'modalButtonText': 'Unarchive Account'
                },
                'archive-site': {
                    'modalHeader': 'Archive School?',
                    'modalText': 'Are you sure you want to archive school?',
                    'modalButtonText': 'Archive School'
                },
                'unarchive-site': {
                   'modalHeader': 'Unarchive School?',
                   'modalText': 'Are you sure you want to unarchive school?',
                   'modalButtonText': 'Unarchive School'
                }
            };

            var modalOptions = {
                'formAction': formAction,
                'formToken': formToken
            };

            $.extend(modalOptions, modalContent[quickActionCode]);

            this.modal && this.modal.destroy();
            this.modal = new ArchiveUnarchiveModal({
                'model': new Backbone.Model(modalOptions)
            });

           $('body').append(this.modal.render().$el);
        },

        "initializeLicenseDatePickers": function() {
            var dateFormat = document.documentElement.lang && ['en_GB', 'sv'].indexOf(document.documentElement.lang) > -1 ? 'dd/mm/yy' : 'mm/dd/yy';

            if (this.$('.admin-form--licensing').length) {
                var $endDateInput = this.$('#end_date_ui'),
                    $startDateInput = this.$('#start_date'),
                    startDateValue = $startDateInput.val();

                if (startDateValue) {
                    // init Start Date and default to startDateVal
                    $startDateInput.datepicker({'dateFormat': dateFormat, 'changeMonth': true, 'changeYear': true}).datepicker('setDate', startDateValue);
                } else {
                    // init Start Date and default to today
                    $startDateInput.datepicker({'dateFormat': dateFormat, 'changeMonth': true, 'changeYear': true}).datepicker('setDate', new Date());
                }

                var startDate = $startDateInput.datepicker('getDate');
                var startDatePlus1 = new Date(startDate); // copy start date
                startDatePlus1.setDate(startDatePlus1.getDate() + 1); // mutates to start date + 1 day

                // init End Date, bind altField and set minDate
                $endDateInput.datepicker({
                    'dateFormat': dateFormat,
                    'changeMonth': true,
                    'changeYear': true,
                    'altField': '#end_date',
                    'minDate': startDatePlus1
                    });
            }
        },

        "onChangeLicenseDuration": function() {
            var duration = Number(this.$('#duration').val()),
                calculatedDuration = duration > 0 ? true : false,
                customDuration = duration === 0 ? true : false,
                expireDuration = duration === -1 ? true : false,
                $startDateInput = this.$('#start_date'),
                $endDateInput = this.$('#end_date_ui'),
                startDate = $startDateInput.datepicker('getDate'),
                startDatePlus1 = new Date(startDate); // copy start date

            startDatePlus1.setDate(startDatePlus1.getDate() + 1); // mutates to start date + 1 day

            // reset comet form errors and validation messages
            this.removeCometFormError('#start_date');
            this.removeCometFormError('#end_date_ui');
            if (this['validationMessage#start_date']) {
                this['validationMessage#start_date'].destroy();
            }
            if (this['validationMessage#end_date_ui']) {
                this['validationMessage#end_date_ui'].destroy();
            }

            if (calculatedDuration){
                $startDateInput.datepicker('option', {'disabled': false }); // enable input
                if (!$startDateInput.val()){
                    $startDateInput.datepicker('setDate', new Date());
                }
                $endDateInput.datepicker('option', {'disabled': true }); // disable input
                this.setLicenseEndDate();
            } else if (customDuration){
                $startDateInput.datepicker('option', {'disabled': false }); // enable input
                $endDateInput.datepicker('option', {'disabled': false }); // enable input
                $endDateInput.datepicker('setDate', null); // clear date
                $endDateInput.datepicker('option', 'minDate', startDatePlus1); // force enddate > startdate
            } else if (expireDuration) {
                $startDateInput.datepicker('option', {'disabled': true }); // disable input
                $endDateInput.datepicker('option', {'disabled': true }); // disable input
                $startDateInput.datepicker('setDate', null); // clear date
                $endDateInput.datepicker('setDate', null); // clear date
            }
        },

        "setLicenseEndDate": function(){
            // calculates and sets date-picker end date based on start date and selected duration
            var $startDateInput = this.$('#start_date');
            var $endDateInput = this.$('#end_date_ui');
            var duration = Number(this.$('#duration').val());
            var customDuration = duration === 0 ? true : false;

            var startDate = $startDateInput.datepicker('getDate');
            if (!startDate) {
                return;
            }

            if (customDuration) {
                var startDate = $startDateInput.datepicker('getDate');
                var startDatePlus1 = new Date(startDate); // copy start date
                startDatePlus1.setDate(startDatePlus1.getDate() + 1); // mutates to start date + 1 day

                // clear end date and set minDate
                $endDateInput.datepicker('setDate', null); // clear date
                $endDateInput.datepicker('option', 'minDate', startDatePlus1); // force enddate > startdate

            } else {
                var calculatedEndDate = new Date(startDate); // copy start date
                calculatedEndDate.setDate(calculatedEndDate.getDate() + duration); // mutates to start date + duration
                $endDateInput.datepicker('setDate', calculatedEndDate);
            }
        },

        "initializeAllSelect2": function(){
            /*
                finds all select inputs with 'select2-initialize' data attribute and intializes with initializeSelect2()
            */
            this.$('select[data-select2-initialize]').each(_.bind(function(index, input){
                this.initializeSelect2($(input));
            }, this));
        },

        "initializeSelect2": function($target){
            /*
                generic select2 initializer that grabs select2 options from <select> element (https://select2.org/configuration/data-attributes)
                and api-specific options from getSelect2AjaxOptions();
            */

            // collect options from <select> element data attributes
            var useApi = $target.data('select2-fetch');
            var ajaxOptionsName = $target.data('select2-ajax-options-name');
            var searchPlaceholderText = $target.data('select2-search-placeholder-text');
            var minimumInputLength = $target.data('select2-minimum-input-length');

            // build select2 options object
            var select2Options = {};

            // extend select2Options with ajax option
            if (useApi) {
                var ajaxOptions = this.getSelect2AjaxOptions(ajaxOptionsName, $target);

                _.extend(select2Options, {
                    'ajax': ajaxOptions,
                    'minimumInputLength': minimumInputLength,
                    'language': {
                      'inputTooShort': function () { return searchPlaceholderText;}
                    },
                });
            }

            $target.select2(select2Options);

            // Hide select2 dropdown on admin-form--edit-school-ids
            if ($target.parents('.admin-form--edit-school-ids').length) {
                $target.on('select2:open', function(e) {
                    $('.select2-results__options').parents('.select2-container').css('display', 'none');
                });
            }
        },

        "initializeAllDatePickers": function(){
            /*
                finds all select inputs with 'datepicker-initialize' data attribute and intializes
            */
            this.$('[data-datepicker-initialize]').each(_.bind(function(index, input){
                $(input).datepicker();
            }, this));
        },

        "onChangeDatepickerTriggerMindate": function(e){
            /*
                Targets an element specified in 'datepicker-trigger-mindate-target' data attribute
                to set a jQueryUI datepicker minDate (https://api.jqueryui.com/datepicker/#option-minDate)
            */
            var $currentTarget = this.$(e.currentTarget);
            var currentTargetDate = $currentTarget.datepicker('getDate');
            var currentTargetDatePlus1 = new Date(currentTargetDate); // copy start date
            currentTargetDatePlus1.setDate(currentTargetDatePlus1.getDate() + 1); // mutates to start date + 1 day

            // get target element from event element
            var mindateTargetName = $currentTarget.data('datepicker-trigger-mindate-target');
            var $mindateTarget = this.$(mindateTargetName);

            $mindateTarget.datepicker('option', 'minDate', currentTargetDatePlus1);
        },

        "getSelect2AjaxOptions": function(name, $target){
            var archiveStatus;

            if ($target) {
                archiveStatus = $target.data('archive-status');
            }

            var accountAjaxOptions = {
                'url': '/v1/accounts/prefix-search',
                'delay': 250,
                'type': 'GET',
                'data': function(params) {
                    var query = {
                        'prefix': params.term
                    };

                    if (archiveStatus) {
                        _.extend(query, {
                            'status': archiveStatus
                        });
                    }
                    return query;
                },
                'processResults': function(data, params){
                    return {
                        'results': _.map(data.accounts, function (account) {
                            account.text = account.name;
                            if (account.is_archived) {
                                account.text += ' (Archived)';
                            }
                            return account;
                        })
                    };
                }
            };

            var siteAjaxOptions = {
                'url': '/v1/sites/prefix-search',
                'delay': 250,
                'type': 'GET',
                'data': _.bind(function(params) {
                    var selectedAccountGuid = this.$('#district').val();
                    var query = {
                            'prefix': params.term
                    };

                    // add user-selected account_guid to query if it is selected
                    if (selectedAccountGuid && this.isGuid(selectedAccountGuid)) {
                        _.extend(query, {
                            'account_guid': selectedAccountGuid
                        });
                    }

                    if (archiveStatus) {
                        _.extend(query, {
                            'status': archiveStatus
                        });
                    }

                    return query;
                }, this),
                'processResults': function(data, params){
                    return {
                        'results': _.map(data.sites, function (site) {
                            site.text = site.name;
                            if (site.is_archived) {
                                site.text += ' (Archived)';
                            }
                            return site;
                        })
                    };
                }
            };

            switch (name) {
                case 'account':
                    return accountAjaxOptions;

                case 'site':
                    return siteAjaxOptions;
            }
        },

        "onBrowseUsersAndClassroomsDistrictChange": function(e){
            var $currentTarget = $(e.currentTarget);
            var updateSchoolsId = $currentTarget.data('updateSchoolsId');
            var $schoolSelect = this.$('#' + updateSchoolsId);
            var districtValue = $currentTarget.val();
            var accountGuid;

            $schoolSelect.empty();
            $schoolSelect.append('<option>');
            $schoolSelect.trigger('change');

            if (this.isGuid(districtValue)) {
                accountGuid = districtValue;
            }

            if (accountGuid) {

                var ajaxOptions = {
                    'context': this,
                    'url': '/v1/accounts/' + accountGuid + '/sites?per_page=51'
                };

                $.ajax(ajaxOptions).done(function(data){

                    var results = this.getSelect2AjaxOptions('site').processResults(data).results;

                    if (results.length < 51) {
                        $schoolSelect.select2({
                            'data': results
                        });
                    } else {
                        this.initializeSelect2($schoolSelect);
                    }
                });
            } else {
                this.initializeSelect2($schoolSelect);
            }
        },

        "onChangeSchoolIds": function(e){

            var $currentTarget = $(e.currentTarget);
            var apiUrl = $currentTarget.data('api-url');
            var targetId = $currentTarget.attr('id');
            var select2InputData = $currentTarget.select2('data');
            var school_ids = _.map(select2InputData, function(i){ return i.text.trim(); });

            this.appendValidationMessage('#' + targetId, 'waiting', 'Saving');

            var postData = JSON.stringify({
                'school_ids': school_ids
            });

            var ajaxOptions = {
                'context': this,
                'url': apiUrl,
                'type': 'PATCH',
                'dataType': 'json',
                'contentType': 'application/json',
                'xhrFields': {
                    'withCredentials': true
                  },
                'data': postData,
                'beforeSend': _.bind(function(){
                    // cancel previous request before starting new request
                    if (this.updateSchoolIdsXHR !== null && this.updateSchoolIdsXHR.readyState !== 4) {
                        this.updateSchoolIdsXHR.abort();
                    };
                }, this),
            };

            this.updateSchoolIdsXHR = $.ajax(ajaxOptions)
                .done(function(data){
                    var savedSchoolIds = data.data.school_ids;

                    this.appendValidationMessage('#' + targetId, 'valid', data.message);

                    if (savedSchoolIds.length) {
                        var mappedSchoolIds = _.map(savedSchoolIds, function(school_id){
                            return {'id': school_id, 'text': school_id, 'selected': true };
                        });
                        $currentTarget.empty();
                        $currentTarget.select2({'data': mappedSchoolIds});
                        $currentTarget.select2('focus');
                    } else {
                        $currentTarget.empty();
                    }
                })
                .fail(_.bind(function(jqxhr, textStatus, error) {
                        var err = textStatus + ", " + error;
                        window.console.log("Request Failed: " + err);
                        var message = jqxhr.responseJSON.meta.message;
                        this.appendValidationMessage('#' + targetId, 'invalid', message);
                }, this));
        },

        "getUserDistrictAssociationsDistricts": _.debounce(function(e){
            var requestSettings = {
                'context': this,
                'url': '/v1/accounts/prefix-search',
                'method': "GET",
                'data': {
                    'prefix': e.currentTarget.value.trim(),
                    'limit': 100
                },
                "beforeSend": _.bind(function(){
                    this.populateSelectInput('account-search-results', [], true);
                    // cancel previous request before starting new request
                    if (this.userDistrictPrefixSearch !== null && this.userDistrictPrefixSearch.readystate !== 4) {
                        this.userDistrictPrefixSearch.abort();
                    };
                }, this),
            };

            if (e.currentTarget.value.length) {
                this.userDistrictPrefixSearch = $.ajax(requestSettings).done(function(data){
                    if (data.accounts.length) {
                        // filter out any previously selected districts from search results
                        var associatedDistrictsIds = _.map($('#associated-districts option'), function(i) { return i.value; });
                        var filteredAccounts = _.filter(data.accounts, function(account){
                            return associatedDistrictsIds.indexOf(account.id) === -1;
                        });
                        if (filteredAccounts.length) {
                            // add 'value' key
                            var selectOptions = _.map(filteredAccounts, function(account){
                                account.value = account.id;
                                return account;
                            });
                        } else {
                            this.populateSelectInput('account-search-results', [{'name': 'No results found'}]);
                        }
                        this.populateSelectInput('account-search-results', selectOptions);
                    } else {
                        this.populateSelectInput('account-search-results', [{'name': 'No results found'}]);
                    }
                });
            } else {
                this.populateSelectInput('account-search-results', [], true);
            }
        }, 500),

        "initializeAccountImportData": function() {
            if (!this.$('.last-import-template').length) {
                return;
            }

            var accountGuid = $('.account-guid-value').data('accountGuid');
            var url = '/v1/accounts/' + accountGuid + '/last-import';

            $.ajax({
                'type': 'GET',
                'context': this,
                'url': url,
                'xhrFields': {
                    'withCredentials': true
                },
                'success': function(data) {
                    if (data.import_found) {
                        this.$('.last-import-date').html(moment(data.date).format("MMMM Do YYYY, h:mm:ss a [GMT]ZZ"));
                        if (data.app_user_guid){
                            var userUrl = '/users/' + data.app_user_guid;
                            this.$('.last-import-user').replaceWith('(by <a href="' + userUrl + '">this user</a>)');
                        }
                        this.$('.last-import-template').html(data.template);

                        if (this.$('.last-import-sync-type').length) {
                            this.$('.last-import-sync-type').html(data.sync_type);
                        }
                    } else {
                        this.$('.last-import-date').html('No import found.');
                        this.$('.last-import-template').html('');
                        if (this.$('.last-import-sync-type').length) {
                            this.$('.last-import-sync-type').html('');
                        }
                    }
                },
                'error': function(xhr, status, error) {
                    var errorMessage = 'Error - Status code ' + xhr.status;
                    if (xhr.responseJSON && xhr.responseJSON.meta) {
                        errorMessage = errorMessage + ': ' + xhr.responseJSON.meta.message;
                    }
                    this.$('.last-import-date').html(errorMessage);
                    this.$('.last-import-template').html('');
                    if (this.$('.last-import-sync-type').length) {
                        this.$('.last-import-sync-type').html('');
                    }
                }
            });
        },

        "initializeAccountSelect": function() {
            var $accountSelect = this.$('.js-admin-select2--account-search');
            var accountSelectisMultiple = $accountSelect.attr('multiple') === 'multiple';
            var placeholder;
            var url = '/v1/accounts/prefix-search';

            if (accountSelectisMultiple) {
                placeholder = 'Search and Select District(s)';
            } else {
                placeholder = 'Select District';
            }

            if (!$accountSelect.length) {
                return;
            }

            $accountSelect.select2({
                'placeholder': placeholder,
                'width': '100%',
                // 'placeholder': { // blank placeholder needed for allowClear
                //     'id': '',
                //     'text': ''
                //   },
                'allowClear': true,
                'minimumInputLength': 1,
                'language': {
                    // You can find all of the options in the language files provided in the
                    // build. They all must be functions that return the string that should be
                    // displayed.
                  'inputTooShort': function () {
                      return "Search by account name or account GUID";
                  }
                },
                'ajax': {
                    'url': url,
                    'delay': 250,
                    'type': 'GET',

                    'data': function(params) {
                        var query = {
                                'prefix': params.term
                        };
                        return query;
                    },

                    'processResults': function(data, params) {
                        /*
                            Select2 expects the following data format.
                            Each object should contain, at a minimum, an id and a text property:

                            {
                              "results": [
                                {
                                  "id": 1,
                                  "text": "Option 1"
                                },
                                {
                                  "id": 2,
                                  "text": "Option 2",
                                  "selected": true
                                },
                                {
                                  "id": 3,
                                  "text": "Option 3",
                                  "disabled": true
                                }
                              ]
                            }
                        */

                        var resultsArray = _.map(data.accounts, function (account) {
                                account.text = account.name;
                                return account;
                            });

                        return {
                            'results': resultsArray
                        };
                    },
               },
            });
        },

        "initializeSiteSelect": function() {
            var url = '/v1/sites/prefix-search',
                $siteSearch;

            $siteSearch = this.$('.js-admin-select2--site-search');

            if (!$siteSearch.length) {
                return;
            }

            $siteSearch.select2({
                'placeholder': 'Select School',
                'width': '100%',
                // 'placeholder': { // blank placeholder needed for allowClear
                //     'id': '',
                //     'text': ''
                //   },
                'allowClear': true,
                'minimumInputLength': 1,
                'language': {
                    // You can find all of the options in the language files provided in the
                    // build. They all must be functions that return the string that should be
                    // displayed.
                  'inputTooShort': function () {
                      return "Search by site name or site GUID";
                  }
                },
                'ajax': {
                    'url': url,
                    'delay': 250,
                    'type': 'GET',

                    'data': function(params) {
                        var selectedAccountGuid = $('select[name="account_guid"]').val() || $('select[name="target_account_guid"]').val();

                        var query = {
                                'prefix': params.term
                        };

                        // add user-selected account_guid to query if it is selected
                        if (selectedAccountGuid) {
                            _.extend(query, {
                                'account_guid': selectedAccountGuid
                            });
                        }

                        return query;
                    },

                    'processResults': function(data, params) {
                        /*
                            Select2 expects the following data format.
                            Each object should contain, at a minimum, an id and a text property:

                            {
                              "results": [
                                {
                                  "id": 1,
                                  "text": "Option 1"
                                },
                                {
                                  "id": 2,
                                  "text": "Option 2",
                                  "selected": true
                                },
                                {
                                  "id": 3,
                                  "text": "Option 3",
                                  "disabled": true
                                }
                              ]
                            }
                        */

                        var resultsArray = _.map(data.sites, function (site) {
                                site.text = site.name;
                                return site;
                            });

                        return {
                            'results': resultsArray
                        };
                    },
               },
            });
        },

        "initializeAssignedAccountsSelect": function() {
            var $associatedAccountsSelect = this.$('.admin-form--user #associated_accounts'),
                optionCount;

            if ($associatedAccountsSelect.length) {
                optionCount = this.$('.admin-form--user #associated_accounts option').length;

                if (optionCount > 0) {
                    $associatedAccountsSelect.select2();
                } else {
                    $associatedAccountsSelect.addClass('js-admin-select2--account-search');
                    this.initializeAccountSelect();
                }
            }
        },

        "initializeEligibleTeachersSelect": function (e) {
            if (this.$('.admin-form--add-class #teachers').length || this.$('.admin-form--edit-class #teachers').length) {
                var $target = this.$('#teachers');
                var apiUrl = $target.data(apiUrl);
                var select2Options = {
                    'width': '100%',
                    'language': {
                        'noResults': function() { return 'No teachers found'; }
                    },
                    'ajax': {
                        'data': function (params) {
                            var query = {
                                'q': params.term,
                                'page': params.page || 1
                            };
                            return query;
                        },
                        'xhrFields': {
                            'withCredentials': true
                        },
                        'processResults': function (data) {
                            _.extend(data.pagination, { 'more': data.pagination.has_next });
                            return data;
                        }
                    }
                };

                $target.select2(select2Options);
            }
        },

        "toggleInternalAdminForms": function(e){
            var $currentTarget = $(e.currentTarget);
            var tab = $currentTarget.data('tab');

            this.$('.internal-admin-forms__tab')
                .addClass('internal-admin-forms__tab--hidden')
                .attr('aria-hidden', 'true');

            this.$('.internal-admin-forms__tab[data-tab=' + tab + ']')
                .removeClass('internal-admin-forms__tab--hidden')
                .attr('aria-hidden', 'false');
          },

          "disableLicenseUpdate": function(){
            this.$('button[name="is_update"]').prop('disabled', true).addClass('comet-button--disabled');
            this.$('.comet-block-message--reload-results').removeClass('hidden');
          },

        "selectCometLabel": function(e){
            var $currentTarget = $(e.currentTarget);
            var $cometTabLabels = $currentTarget.closest('.comet-tabs').find('.comet-tab__label');
            $cometTabLabels.removeClass('comet-tab__label--selected');
            $currentTarget.addClass('comet-tab__label--selected');
        },

        // cobranding form fns

        "onClickPreview": function(e) {
            e.preventDefault();

            this.validateCobrandingForm();

            var formValid = !this.$('form[name="cobranding"] .comet-form--error').length;
            if (!formValid) {
                return;
            }

            // get user input values
            var prevImgSrc = this.$('.footer-cobranding-logo').attr('src');
            var selectedImage = this.$('input[name="image"]')[0].files[0];
            var customText = this.$('input[name="custom_text"]').val();
            var sponsorName = this.$('input[name="name"]').val();
            var url = this.$('input[name="url"]').val();

            // append template and image
            this.$('.footer-cobranding-container').html(footerCobrandingTemplate({
                "page_data": {
                    "navigation": {
                        "cobranding": {
                            "text": customText,
                            "name": sponsorName,
                            "url": url
                        }
                    }
                }
            }));

            this.appendImage(selectedImage, prevImgSrc);
        },

        "validateCobrandingForm": function(){
            var requiredInputs = this.$('.admin-cobranding-form-container input.required');

            _.each(requiredInputs, function(input){
                var $input = $(input);
                $input.removeClass('comet-form--error');
                if (!$input.val()) {
                    $input.addClass('comet-form--error');
                }
            });
        },

        "appendImage": function(file, prevImgSrc) {

            var $cobrandingLogoContainer = this.$('.footer-cobranding-logo-container');

            if (file) {
                var imageType = /image.*/;

                if (file.type.match(imageType)) {
                    var reader = new FileReader();

                    reader.onload = function(e) {
                        var $img = $(new Image());
                        $img.attr('src', reader.result);
                        $img.addClass('footer-cobranding-logo');
                        $cobrandingLogoContainer.html('');
                        $cobrandingLogoContainer.append($img);
                    };
                    reader.readAsDataURL(file);
                }

            } else if (prevImgSrc) {
                var $img = $(new Image());
                $img.attr('src', prevImgSrc);
                $img.addClass('footer-cobranding-logo');
                $cobrandingLogoContainer.html('');
                $cobrandingLogoContainer.append($img);
            }
        },

        // privacy notice fns

        "showPrivacyNotice": function(){
            if (!this.privacyNoticeDismissed) {
                this.$('.admin-privacy-top-hat').removeClass('hidden').attr('aria-hidden', 'false');
            }
        },

        "dismissPrivacyNotice": function(){
            var $privacyNotice = this.$('.admin-privacy-top-hat');
            var privacyNoticeHeight = $privacyNotice.height();
            // use negative margin to preserve css transition
            $privacyNotice.css('margin-top', -privacyNoticeHeight).attr('aria-hidden', 'true');

            sessionStorage.setItem('admin-privacy-notice-dismissed', true);
            this.privacyNoticeDismissed = true;
        },

        "archiveUserModal": function(e){
            e.preventDefault();

            var userGuid = $(e.currentTarget).data('user-guid');

            this.modal && this.modal.destroy();
            this.modal = new ArchiveUserConfirmModal({
                'model': new Backbone.Model({'userGuid': userGuid})
            });

            $('body').append(this.modal.render().$el);
        },

        "unarchiveUserModal": function(e){
            e.preventDefault();

            var userGuid = $(e.currentTarget).data('user-guid');

            this.modal && this.modal.destroy();
            this.modal = new UnArchiveUserConfirmModal({
                'model': new Backbone.Model({'userGuid': userGuid})
            });

            $('body').append(this.modal.render().$el);
        },

        "archiveClassModal": function(e){
            e.preventDefault();

            var classGuid = $(e.currentTarget).data('class-guid');

            this.modal && this.modal.destroy();
            this.modal = new ArchiveClassConfirmModal({
                'model': new Backbone.Model({'classGuid': classGuid})
            });

            $('body').append(this.modal.render().$el);
        },

        "unarchiveClassModal": function(e){
            e.preventDefault();

            var classGuid = $(e.currentTarget).data('class-guid');

            this.modal && this.modal.destroy();
            this.modal = new UnarchiveClassConfirmModal({
                'model': new Backbone.Model({'classGuid': classGuid})
            });

            $('body').append(this.modal.render().$el);
        },

        "duplicateClassModal": function(e){
            e.preventDefault();

            var classGuid = $(e.currentTarget).data('class-guid');

            this.modal && this.modal.destroy();
            this.modal = new DuplicateClassConfirmModal({
                'model': new Backbone.Model({'classGuid': classGuid})
            });

            $('body').append(this.modal.render().$el);
        },

        "sendDomainVerificationCodeModal": function (e) {
            e.preventDefault();
            var $currentTarget = $(e.currentTarget);
            var apiUrl = $currentTarget.data('api-url');
            var token = $currentTarget.data('token');
            var localPart = this.$('#local-part').val();
            var domain = this.$('#domain').val().trim();


            this.modal && this.modal.destroy();
            this.modal = new SendDomainVerificationCodeModal({
                'model': new Backbone.Model({
                    'apiUrl': apiUrl,
                    'token': token,
                    'localPart': localPart,
                    'domain': domain
                })
            });

            $('body').append(this.modal.render().$el);

        },

        "displayAddDomainBtn": function (e) {
            var $code = $(e.currentTarget);
            var $addPrimaryDomainBtn = $('.admin-form__button--add');
            var trimmedCode = $code.val().trim();

            $addPrimaryDomainBtn.attr('disabled', !trimmedCode);
        },

        "leaveServiceDataDetailsForm": function (e) {
            var nextUrl = $(e.currentTarget).data('next-url');
            var formInputs = this.$('.admin-form.service-data-details input[type=text]');
            var inputsWithValue = _.filter(formInputs, function (i) { return i.value; });
            if (inputsWithValue.length) {
                this.modal && this.modal.destroy();
                this.modal = new LeaveServiceDataDetailsFormModal({
                    'model': new Backbone.Model({
                        'nextUrl': nextUrl,
                        'modalHeader': 'Are you sure you want to go back?',
                        'modalContent': 'You will lose any changes to Service Data Details by going back to Map School IDs'
                    })
                });
                $('body').append(this.modal.render().$el);
            } else {
                window.location.href = nextUrl;
            }
        },

        /**
         * Render the password reset modal.
         *
         * @param {object} modelAttributes initial password reset model attributes
         */
        "renderResetPasswordModal": function(modelAttributes) {
            this.modal && this.modal.destroy();

            this.modal = new ResetPasswordModal({
                'model': new Backbone.Model(modelAttributes),
            });

            $('body').append(this.modal.render().$el);
        },

        /**
         * Before displaying the password reset modal, lets do a quick api call
         *  to fetch the target users feature flags. Lets pass those feature
         *  flags to the password reset model. If something happens and we cannot
         *  get the target users feature flags, lets render the modal anyway
         *  but we will fall back to the logged in users feature flag setting, i.e.
         *  strong passwords.
         *
         * @param {object} e Click event
         */
        "onClickQuickActionResetPassword": function(e) {
            e.preventDefault();

            var apiUrl = $(e.currentTarget).data('api-url'),
                resetPasswordToken = app.initData.get('reset_password_token'),
                username = $(e.currentTarget).data('username'),
                userGuid = $(e.currentTarget).data('user-guid'),
                modelAttributes = {
                    'apiUrl': apiUrl,
                    'token': resetPasswordToken,
                    'userGuid': userGuid,
                    'username': username,
                    'featureFlags': null,
                    'requireStrongPassword': null,
                };

            $.ajax({
                'context': this,
                'url': '/apiproxy/v1/users/require-strong-password?user_guid=' + window.encodeURIComponent(userGuid),
                'xhrFields': {
                  'withCredentials': true
                },
                "beforeSend": function(){
                    // cancel previous request before starting new request
                    if (this.validateEmailAddressXHR !== null && this.validateEmailAddressXHR.readystate !== 4) {
                        this.validateEmailAddressXHR.abort();
                    }
                },
            })
            .done(function(data) {
                modelAttributes.requireStrongPassword = data.require_strong_password;
                this.renderResetPasswordModal(modelAttributes);
            })
            .fail(function() {
                this.renderResetPasswordModal(modelAttributes);
            });

        },

        "onDistrictChange": function(e) {
            var $currentTarget = $(e.currentTarget),
                updateSchoolsId = $currentTarget.data('updateSchoolsId'),
                schoolSelectRequired = $currentTarget.data('update-schools-required'),
                accountGuid = $currentTarget.val(),
                $schoolLabel = this.$("label[for='" + updateSchoolsId + "']"),
                $schoolLabelParent = $schoolLabel.parent();

                this.$('#' + updateSchoolsId).attr('disabled', 'disabled');

            if (accountGuid) {
                $.ajax({
                    "context": this,
                    "url": "/v1/accounts/" + accountGuid + "/sites?per_page=51",
                }).done(function(data){

                    this.$('#' + updateSchoolsId + '.js-admin-select2--site-search').select2('destroy');
                    $schoolLabelParent.children().not($schoolLabel).remove();
                    $schoolLabelParent.append(schoolSelect(_.extend({}, data, {
                        'school_field_name': $currentTarget.data('updateSchoolsFormName'),
                        'school_field_id': updateSchoolsId
                    })));

                    if (schoolSelectRequired) {
                        this.$('#' + updateSchoolsId).addClass('required');
                    }

                    if (data.sites.length > 50) {
                        this.initializeSiteSelect();
                    }
                });
            } else {
                $schoolLabelParent.children().not($schoolLabel).remove();
                $schoolLabelParent.append('<select class="js-admin-select2--site-search" id="school" name="site_guid" ></select>');
                if (schoolSelectRequired) {
                    this.$('#' + updateSchoolsId).addClass('required');
                }
                this.initializeSiteSelect();
            }
        },

        "onCountryChange": function(e){
            var $currentTarget = $(e.currentTarget),
                selectedOptionValue = $currentTarget.val(),
                apiUrl = $currentTarget.data('api-url') + selectedOptionValue + '/regions',
                targetRegion = $currentTarget.data('target-region'),
                regionsNotNone;

                this.unrequireCometFormFieldGroup('#' + targetRegion);

            if (selectedOptionValue) {
                $.ajax({
                    'context': this,
                    'url': apiUrl,
                    'xhrFields': {
                      'withCredentials': true
                    }
                }).done(function(data){
                    var regionsList = _.map(data.regions, function(region){
                        return {
                            'name': region.name,
                            'value': region.region_id
                        };
                    });
                    regionsNotNone = !!regionsList.length;
                    regionsList.unshift({'name': '', 'value': ''});
                    this.populateSelectInput(targetRegion, regionsList, true);
                    if (regionsNotNone) {
                        this.requireCometFormFieldGroup('#' + targetRegion);
                    }
                }).fail(function(jqxhr, textStatus, error) {
                    var err = textStatus + ', ' + error;
                    window.console.log('Request Failed: ' + err);
                    this.populateSelectInput(targetRegion, [{'name': '', 'value': ''}], true);
                    this.removeCometFormError('#' + targetRegion);
                    this.validateInput('#' + targetRegion);
                    this.destroyValidationMessage('#' + targetRegion);
                });
            } else {
                    this.populateSelectInput(targetRegion, [{'name': '', 'value': ''}], true);
                    this.removeCometFormError('#' + targetRegion);
                    this.validateInput('#' + targetRegion);
                    this.destroyValidationMessage('#' + targetRegion);
            }
        },

        "addProductModal": function(e){
            e.preventDefault();

            var form_choices = app.initData.get('form_choices');

            this.modal && this.modal.destroy();
            this.modal = new AddProductModal({
                'model': new Backbone.Model({'form_choices': form_choices})
            }).on("addProducts", this.updateLicenseProductsView, this);

            $('body').append(this.modal.render().$el);
        },

        "onClickModalTrigger": function(e){
            e.preventDefault();
            var modalFunctionName = this.$(e.currentTarget).data('modal-function');
            this[modalFunctionName](e);
        },

        "onClickTriggerReload": function(e){
            window.location.reload();
            return false;
        },

        "onClickCopyToClipboard": function(e){
            var currentTargetVal = this.$(e.currentTarget).val();
            if (currentTargetVal) {
                this.copyToClipboard(currentTargetVal);
            }
        },

        "selectCometTabPanel": function(e){
            var $currentTarget = this.$(e.currentTarget);
            var targetValue = $currentTarget.val() || $currentTarget.data('target-panel');
            var targetTab = this.$('.comet-tab__input' + '#' + targetValue);
            targetTab.prop('checked', true);
        },

        "bulkImportUploadModal": function(e){
            e.preventDefault();

            var templateName = this.$(e.currentTarget).data('template-name');
            var modalTemplate = this.$(e.currentTarget).data('modal-template');
            var allowStudentIdAsPwd = app.initData.get('allow_student_id_as_pwd');
            var hasLoginProvider = app.initData.get('has_login_provider');

            this.modal && this.modal.destroy();
            this.modal = new BulkImportUploadModal({
                "model": new Backbone.Model({
                    "templateName": templateName,
                    "modalHeader": templateName + ".csv",
                    "modalTemplate": modalTemplate,
                    "allowStudentIdAsPwd": allowStudentIdAsPwd,
                    "hasLoginProvider": hasLoginProvider,
                })
            });

            $('body').append(this.modal.render().$el);
        },

        "bulkImportDownloadModal": function(e){
            e.preventDefault();

            var downloadUrl = this.$(e.currentTarget).data('download-url');

            this.modal && this.modal.destroy();
            this.modal = new BulkImportDownloadModal({
                "model": new Backbone.Model({
                    "downloadUrl": downloadUrl
                })
            });

            $('body').append(this.modal.render().$el);
        },

        "onboardingStartOverConfirmModal": function(e){
            e.preventDefault();
            var startOverToken = app.initData.get('start_over_token');

            this.modal && this.modal.destroy();
            this.modal = new OnboardingStartOverModal({
                'model': new Backbone.Model({
                    'token': startOverToken
                })
            });

            $('body').append(this.modal.render().$el);
        },

        "initializeLicenseProductsView": function(){
            var form_choices = app.initData.get('form_choices');

            if (this.$('.admin-form--create-licenses').length){
                this.licenseProducts = new LicenseProducts();
                this.$('.add-products__license_products').append(this.licenseProducts.render().$el);
                // add form choices from previous post that are passed back in initData
                this.licenseProducts.collection.add(form_choices.product_list);
            }
        },

        "updateLicenseProductsView": function(data){
            this.licenseProducts.collection.add(data);
        },

        "validateInput": function(formInput){
            this.$(formInput).removeClass('invalid');
        },

        "invalidateInput": function(formInput){
            this.$(formInput).addClass('invalid');
        },

        "addCometFormError": function(formInput){
            this.$(formInput).closest('.comet-form__field-group').addClass('comet-form--error');
        },

        "removeCometFormError": function(formInput){
            this.$(formInput).closest('.comet-form__field-group').removeClass('comet-form--error');
        },

        "unrequireCometFormFieldGroup": function(target){
            var $target = this.$(target);

            $target.removeClass('invalid required');

            var $formLabel = $target.closest('.comet-form__field-group').find('.comet-form__label');
            $formLabel.find('.comet-form__label-required-indicator').remove();
            $formLabel.find('.comet-screenreader-only').remove();
        },

        "requireCometFormFieldGroup": function(target){
            var $target = this.$(target);

            $target.addClass('required');

            var $formLabel = $target.closest('.comet-form__field-group').find('.comet-form__label');
            if (!$formLabel.has('abbr').length) {
                $formLabel.append('<abbr class="comet-form__label-required-indicator" title="This field is required." aria-hidden="true">*</abbr>');
                $formLabel.append('<span class="comet-screenreader-only">Required Field.</span>');
            }
        },

        "destroyValidationMessage": function(target){
             var validationMessage = "validationMessage" + target;

             if (this[validationMessage]) {
                 this[validationMessage].destroy();
             }
        },

        "appendValidationMessage": function(target, messageType, messageText) {
            var validationMessage = "validationMessage" + target;

            // destroy previous validation messages
            if (this[validationMessage]) {
                this[validationMessage].destroy();
            }

            this[validationMessage] = new ValidationMessage({
                'model': new Backbone.Model({
                    'target': target.substring(1),
                    'messageType': messageType,
                    'messageText': messageText
                })
            });

            this.$(target).closest('.comet-form__field-group').append(this[validationMessage].render().$el);
        },

        "appendBlockMessage": function(target, messageType, messageText) {

            // create a unique variable based on message text
            var blockMessage = "blockMessage" + messageText.replace(/\s+/g, '-').toLowerCase();

            // destroy previous block message
            if (this[blockMessage]) {
                this[blockMessage].destroy();
            }

            this[blockMessage] = new BlockMessage({
                'model': new Backbone.Model({
                    'target': target.substring(1),
                    'message_type': messageType,
                    'message_text': messageText
                })
            });

            this.$(target).append(this[blockMessage].render().$el);
        },

        "destroyBlockMessage": function(messageText) {
            if (messageText) {
                var blockMessage = 'blockMessage' + messageText.replace(/\s+/g, '-').toLowerCase();
                if (this[blockMessage]) {
                    this[blockMessage].destroy();
                }
            } else {
                // destroy all block message views
                var blockMessageViewNames = _.filter(Object.keys(this), function(key){
                    return key.indexOf('blockMessage') === 0;
                });
                _.each(blockMessageViewNames, function(blockMessageName){
                    this[blockMessageName].destroy();
                }, this);
            }
        },

        "onSimpleApiValidatedKeyup": _.debounce(function(e) {

            var id = e.currentTarget.id,
                value = e.currentTarget.value.trim(),
                previousValue = e.currentTarget.getAttribute('data-value'),
                xhrObjectName = 'validate' + this.capitalizeFirstLetter(id) + 'XHR',
                validationViewName = 'validationMessage#' + id;

            var passAsParams = this.$(e.currentTarget).data('passAsParams');

            // invalidate and remove error from input
            this.invalidateInput('#' + id);
            this.removeCometFormError('#' + id);

            if (!value || value === previousValue) {

                this.validateInput('#' + id);

                // cancel possible in-progress xhr request
                if (this[xhrObjectName]) {
                    this[xhrObjectName].abort();
                }
                // destroy possible ValidationMessage view
                if (this[validationViewName]){
                    this[validationViewName].destroy();
                }
            } else {
                this.simpleApiValidate(value, id, passAsParams);
            }
        }, 500),

        "onUsernameKeyup": _.debounce(function(e) {
            this.invalidateInput('#username');
            this.removeCometFormError('#username');
            this.removeCometFormError('#password');

            if (this["validationMessage#password"]) {
                this["validationMessage#password"].destroy();
            }

            if (!this.model.get('is_sso')) {
                this.onPasswordInput();
                this.requireCometFormFieldGroup('#password');
                this.requireCometFormFieldGroup('#password-confirm');
                this.$('.comet-form__field-group.password-container').show();
            } else {
                this.unrequireCometFormFieldGroup('#password');
                this.unrequireCometFormFieldGroup('#password-confirm');
                this.$('.comet-form__field-group.password-container').hide();
            }

            var username = e.currentTarget.value.trim(),
                previousUsername,
                editUserForm = app.initData.get('edit_user_form');

            if (editUserForm) {
                previousUsername = editUserForm.username;
            }

            if (!username) {

                if (this.validateUsernameXHR) {
                    this.validateUsernameXHR.abort();
                }

                if (this['validationMessage#username']){
                    this['validationMessage#username'].destroy();
                }

            } else if (username === previousUsername) {

                if (this.validateUsernameXHR) {
                    this.validateUsernameXHR.abort();
                }

                if (this['validationMessage#username']){
                    this['validationMessage#username'].destroy();
                }

                this.validateInput('#username');

             } else {

                this.validateUsername(username);

            }
        }, 500),

        "onPasswordInput": _.debounce(function() {
            this.invalidateInput('#password');
            this.removeCometFormError('#password');

            if (this['validationMessage#password']){
                this['validationMessage#password'].destroy();
            };

            var passwordConfirmValueExists = this.$('#password-confirm').val();
            var passwordConfirmInErrorState = this.$('#password-confirm').closest('.comet-form__field-group').hasClass('comet-form--error');

            if (passwordConfirmValueExists || passwordConfirmInErrorState) {
                this.validatePasswordConfirm();
            }

            var username = this.$('#username').val().trim();
            var password = this.$('#password').val().trim();

            // optional api form data
            var selectedRoleGuid = this.$('select[name=selected_role]').val();
            var firstName = this.$('#first_name').val().trim();
            var lastName = this.$('#last_name').val().trim();

            if (!password) {

                if (this.validatePasswordXHR) {
                    this.validatePasswordXHR.abort();
                }

                if (this['validationMessage#password']){
                    this['validationMessage#password'].destroy();
                }

             } else {
                this.validatePassword(username, password, selectedRoleGuid, firstName, lastName);
             }
        }, 500),

        "onValidateJSONKeyup": _.debounce(function(e){
            var $currentTarget = $(e.currentTarget);
            var id = $currentTarget.attr('id');
            var val = $currentTarget.val();
            if (!val) {
                this.validateInput($currentTarget);
                this.removeCometFormError($currentTarget);
                this.destroyValidationMessage('#' + id);
            } else {
                if (this.isValidJSON(val)) {
                    this.validateInput($currentTarget);
                    this.removeCometFormError($currentTarget);
                    this.destroyValidationMessage('#' + id);
                } else {
                    this.appendValidationMessage('#' + id, 'invalid', 'Invalid JSON');
                    this.addCometFormError($currentTarget);
                    this.invalidateInput($currentTarget);
                }
            }
        }, 500),

        "onEmailKeyUp": function(e) {
            var $emailEl = $(e.currentTarget),
                isRequired = $emailEl.hasClass('required'),
                email = $emailEl.val(),
                isCurrentEmail = email === $emailEl.data('value');

            if (isCurrentEmail || !isRequired && email === '') {
                this.validateInput($emailEl);
                this.removeCometFormError($emailEl);
                $emailEl.parent().find('.admin-validation-message').remove();
            } else if (!email) {
                this.invalidateInput($emailEl);
            } else {
                this.validateEmailAddress(email);
            }
        },

        "validateEmailAddress": function(emailAddress) {

            this.appendValidationMessage('#email', 'waiting', 'Checking availablity');

            var url = this.$('#email').data('api-url');

            var requestSettings = {
                "url": url,
                "method": "POST",
                "contentType": "application/json",
                "data": JSON.stringify({
                    "email": emailAddress,
                }),
                "beforeSend": _.bind(function(){
                    // cancel previous request before starting new request
                    if (this.validateEmailAddressXHR !== null && this.validateEmailAddressXHR.readystate !== 4) {
                        this.validateEmailAddressXHR.abort();
                    }
                }, this),
            };

            this.validateEmailAddressXHR = $.ajax(requestSettings)
                .done(_.bind(function(data, textStatus, jqXHR) {
                    if (data.available) {
                        this.validateInput('#email');
                        this.appendValidationMessage('#email', 'valid', data.message);
                        this.removeCometFormError('#email');
                    } else {
                        this.invalidateInput('#email');
                        this.appendValidationMessage('#email', 'invalid', data.message);
                        this.addCometFormError('#email');
                    }
                }, this))
                .fail(function(jqxhr, textStatus, error) {
                    var err = textStatus + ", " + error;
                    window.console.log("Request Failed: " + err);
                });
        },

        "validateUsername": function(username) {

            this.appendValidationMessage('#username', 'waiting', 'Checking username');
            var url = this.$('#username').data('api-url');

            var requestSettings = {
                "url": url,
                "method": "POST",
                "contentType": "application/json",
                "data": JSON.stringify({
                    "username": username,
                }),
                "beforeSend": _.bind(function(){
                    // cancel previous request before starting new request
                    if (this.validateUsernameXHR !== null && this.validateUsernameXHR.readystate !== 4) {
                        this.validateUsernameXHR.abort();
                    }
                }, this),
            };

            this.validateUsernameXHR = $.ajax(requestSettings)
                .done(_.bind(function(data, textStatus, jqXHR) {
                    var $strongPassowrdEl = $('.strong-validation__section--rules');

                    if (data.is_valid) {
                        this.removeCometFormError('#username');
                        this.validateInput('#username');
                        this.appendValidationMessage('#username', 'valid', data.message);

                        this.model.set('is_sso', data.is_sso);

                        if (data.is_sso) {
                            this.unrequireCometFormFieldGroup('#password');
                            this.unrequireCometFormFieldGroup('#password-confirm');
                            this.$('.comet-form__field-group.password-container').hide();

                            $strongPassowrdEl.hide();
                        } else {
                            this.$('.comet-form__field-group.password-container').show();
                            $strongPassowrdEl.show();
                        }
                    } else {
                        this.addCometFormError('#username');
                        this.invalidateInput('#username');
                        this.appendValidationMessage('#username', 'invalid', data.message);
                    }
                }, this))
                .fail(function(jqxhr, textStatus, error) {
                    var err = textStatus + ", " + error;
                    window.console.log("Request Failed: " + err);
                });
        },

        "validatePassword": function(username, password, selectedRoleGuid, firstName, lastName) {

            this.appendValidationMessage('#password', 'waiting', 'Checking password');

            var url = this.$('#password').data('validate-password-url');
            var requestData = {
                "username": username,
                "password": password,
                "selected_role_guid": selectedRoleGuid,
                "first_name": firstName,
                "last_name": lastName,
            };

            var requestSettings = {
                "url": url,
                "method": "POST",
                "data": requestData,
                "beforeSend": _.bind(function(){
                    // cancel previous request before starting new request
                    if (this.validatePasswordXHR !== null && this.validatePasswordXHR.readystate !== 4) {
                        this.validatePasswordXHR.abort();
                    }
                }, this),
            };

            this.validatePasswordXHR = $.ajax(requestSettings)
                .done(_.bind(function(data, textStatus, jqXHR) {
                    if (this.featureFlags['strong-passwords-teacheradmins']) {
                        if (this["validationMessage#password"]) {
                            this["validationMessage#password"].destroy();
                        }

                        this.strongValidationView.model.set('validationConfig', data.validation_results);
                        this.strongValidationView.model.set('is_valid', data.is_valid);

                        $('.strong-validation__section--rules').append(this.strongValidationView.render().$el);

                        if (data.is_valid) {
                            this.removeCometFormError('#password');
                            this.validateInput('#password');
                            this.appendValidationMessage('#password', 'valid', data.message);
                        } else {
                            this.addCometFormError('#password');
                            this.invalidateInput('#password');
                        }
                    } else {
                        if (data.is_valid) {
                            this.removeCometFormError('#password');
                            this.validateInput('#password');
                            this.appendValidationMessage('#password', 'valid', data.message);
                        } else {
                            this.addCometFormError('#password');
                            this.invalidateInput('#password');
                            this.appendValidationMessage('#password', 'invalid', data.message);
                        }
                    }
                }, this))
                .fail(function(jqxhr, textStatus, error) {
                    var err = textStatus + ", " + error;
                    window.console.log("Request Failed: " + err);
                });
        },

        "validatePasswordConfirm": function() {

            this.invalidateInput('#password-confirm');
            this.removeCometFormError('#password-confirm');

            var password = this.$('.admin-form--user #password').val(),
                passwordConfirm = this.$('.admin-form--user #password-confirm').val();

            if (!passwordConfirm){
                if (this['validationMessage#password-confirm']){
                    this['validationMessage#password-confirm'].destroy();
                }
            } else {
                if (password === passwordConfirm) {
                    this.appendValidationMessage('#password-confirm', 'valid', 'Passwords match');
                    this.removeCometFormError('#password-confirm');
                    this.validateInput('#password-confirm');
                } else {
                    this.appendValidationMessage('#password-confirm', 'invalid', 'Passwords do not match');
                    this.addCometFormError('#password-confirm');
                    this.invalidateInput('#password-confirm');
                }
            }
        },

        "simpleApiValidate": function(value, id, passAsParams) {
            var targetId = '#' + id;
            var apiUrl = this.$(targetId).data('api-url');
            var apiMethod = this.$(targetId).data('api-method');
            var friendlyName = this.$(targetId).data('friendly-name') || id;
            var url = apiUrl;
            var xhrObjectName = 'validate' + this.capitalizeFirstLetter(id) + 'XHR';
            var postData = {};

            this.appendValidationMessage(targetId, 'waiting', 'Checking ' + friendlyName);

            url = passAsParams ? url + '?' + this.$(targetId).attr('name') + '=' + value :
                url + value;

            var requestSettings = {
                "url": url,
                "method": "GET",
                'xhrFields': {
                    'withCredentials': true
                  },
                "beforeSend": _.bind(function(){
                    // cancel previous request before starting new request
                    if (this[xhrObjectName] !== null && this[xhrObjectName].readystate !== 4) {
                        this[xhrObjectName].abort();
                    }
                }, this),
            };

            if (apiMethod === 'POST') {
                postData[id] = value;
                _.extend(requestSettings, {
                    'url': apiUrl,
                    'method': 'POST',
                    'data': postData
                });
            }

            this[xhrObjectName] = $.ajax(requestSettings)
                .done(_.bind(function(data, textStatus, jqXHR) {
                    if (data.valid) {
                        this.removeCometFormError(targetId);
                        this.validateInput(targetId);
                        this.appendValidationMessage(targetId, 'valid', data.message);
                    } else {
                        this.addCometFormError(targetId);
                        this.invalidateInput(targetId);
                        this.appendValidationMessage(targetId, 'invalid', data.message);
                    }
                }, this))
                .fail(_.bind(function(jqXHR, textStatus, errorThrown) {
                    var err = 'Request Failed: ' + textStatus;
                    window.console.log(err);
                    this.addCometFormError(targetId);
                    this.invalidateInput(targetId);
                    this.appendValidationMessage(targetId, 'invalid', err);
                }, this));
        },

        "onFormSubmit": function(e) {
            var $form = $(e.currentTarget);

            this.validateRequired($form);
            this.customValidation($form);

            var invalidFieldsExist = $form.find('.invalid').length;

            if (invalidFieldsExist) {
                return false;
            }

            var itemsToDisable = $form.find('[data-disable-on-before-submit]');
            _.each(itemsToDisable, function (i) {
                this.disableElement(i);
            }, this);
        },

        "validateRequired": function($form) {

            var requiredInputs = $form.find('.comet-form__input.required:not(:disabled), select.required:not(:disabled)');

            _.each(requiredInputs, function(input){

                var apiValidated = this.$(input).hasClass('api-validated');

                var validationMessage = 'validationMessage#' + input.id;

                if (this[validationMessage] && !apiValidated){
                    this[validationMessage].destroy();
                };

                if (input.value.trim().length < 1) {
                    this.addCometFormError(input);
                    this.invalidateInput(input);
                    this.appendValidationMessage("#" + input.id, 'invalid', 'This field is required');
                } else {
                     if (!apiValidated) {
                        this.removeCometFormError(input);
                        this.validateInput(input);
                     }
                }
            }, this);
        },

        /* eslint-disable complexity */
        "customValidation": function($form) {
            var formId = $form.attr('id');

            switch (formId) {
                case 'admin-form--create-licenses':
                    var skuIdCount = this.$('#sku-ids-list .license-products tr').length,
                        schoolIdCount = this.$('#school-ids-checkbox-group input:checked').length,
                        skuIdMessage = 'At least one product is required',
                        schoolIdMessage = 'Select at least one school';

                    if (skuIdCount) {
                        this.destroyBlockMessage(skuIdMessage);
                        this.validateInput('#sku-ids-list');
                    } else {
                        this.invalidateInput('#sku-ids-list');
                        this.appendBlockMessage('.block-message-container', 'error', skuIdMessage);
                    }

                    // only check school ids if the controls are present
                    if (schoolIdCount || !this.$("#school-ids-checkbox-group").length) {

                        this.destroyBlockMessage(schoolIdMessage);
                        this.validateInput('#school-ids-checkbox-group');
                    } else {
                        this.invalidateInput('#school-ids-checkbox-group');
                        this.appendBlockMessage('.block-message-container', 'error', schoolIdMessage);
                    }

                case 'admin-form--add-site':
                case 'admin-form--add-account':
                    // require address-1, city, postal-code if Shipping or Billing address fields are partially filled out
                    var shippingAddressInputIds = ['#shipping-address-1', '#shipping-address-2', '#shipping-address-3', '#shipping-city', '#shipping-postal-code', '#shipping-country', '#shipping-region'];
                    var requiredShippingAddressInputIds = ['#shipping-address-1', '#shipping-city', '#shipping-postal-code', '#shipping-country'];
                    var billingAddressInputIds = ['#billing-address-1', '#billing-address-2', '#billing-address-3', '#billing-city', '#billing-postal-code'];
                    var requiredBillingAddressInputIds = ['#billing-address-1', '#billing-city', '#billing-postal-code', '#billing-country'];

                    var inputValueExistsForAnyShippingAddressField = _.some(shippingAddressInputIds, function(id){
                        return !!this.$(id).val();
                    }, this);

                    var inputValueExistsForAnyBillingAddressField = _.some(billingAddressInputIds, function(id){
                        return !!this.$(id).val();
                    }, this);

                    if (inputValueExistsForAnyShippingAddressField) {

                        _.each(requiredShippingAddressInputIds, function(id){
                            this.$(id).addClass('required');
                        }, this);

                        this.validateRequired($form);

                        var invalidFieldsExist = _.some(requiredShippingAddressInputIds, function(id){
                            return this.$(id).hasClass('invalid');
                        }, this);

                        if (invalidFieldsExist) {
                            this.$('label[for="shipping-address-details"]').click();
                        }

                    } else {

                        _.each(requiredShippingAddressInputIds, function(id){
                            this.$(id).removeClass('required');
                            this.removeCometFormError(id);
                            this.destroyValidationMessage(id);
                            this.validateInput(id);
                        }, this);

                        this.validateRequired($form);
                    }

                    if (inputValueExistsForAnyBillingAddressField) {

                        _.each(requiredBillingAddressInputIds, function(id){
                            this.$(id).addClass('required');
                        }, this);

                        this.validateRequired($form);

                        var invalidFieldsExist = _.some(requiredBillingAddressInputIds, function(id){
                            return this.$(id).hasClass('invalid');
                        }, this);

                        if (invalidFieldsExist) {
                            this.$('label[for="billing-address-details"]').click();
                        }

                    } else {

                        _.each(requiredBillingAddressInputIds, function(id){
                            this.$(id).removeClass('required');
                            this.removeCometFormError(id);
                            this.destroyValidationMessage(id);
                            this.validateInput(id);
                        }, this);

                        this.validateRequired($form);
                    }

                    // if main-region has a length of more than 1, require it
                    var $mainRegionSelect = this.$('#main-region');
                    var mainRegionOptionsLength = $mainRegionSelect.find('option').length;
                    var mainRegionSelectionRequired = mainRegionOptionsLength > 1;

                    if (mainRegionSelectionRequired) {
                        $mainRegionSelect.addClass('required');
                        this.validateRequired($form);
                    } else {
                        $mainRegionSelect.removeClass('required');
                        this.removeCometFormError('#main-region');
                        this.validateInput('#main-region');
                        this.destroyValidationMessage('#main-region');
                    }

                case 'admin-form--user-district-associations':
                    this.$('#associated-districts option').prop('selected', true);
                case 'admin-form--edit-campaign':
                case 'admin-form--add-campaign':
                    this.$('#products option').prop('selected', true);
                break;
            }
        },
        /* eslint-enable complexity */

        "postFormOnSelectChange": function(e){
            var $currentTarget = $(e.currentTarget);
            $currentTarget.val() && $currentTarget.parents("form").submit();
        },

        "onChangeEntityType": function(e){
            var sale_entity_type = "ffffffff-ffff-aaaa-bbbb-000000000005";
            var unverified_entity_type = "8c0d405c-8309-4c83-8c2c-f3326b49c709";

            var sfid_required_entity_types = [sale_entity_type, unverified_entity_type];

            var entityTypeGuid = $(e.currentTarget).val();
            var sfidInputId = 'sfid';
            var sfidInput = $("input#" + sfidInputId);
            var sfidWrapper = $('.admin-form__sfid-wrapper');
            var sfidRequiredAsterisk = $("#sfid-required-asterisk");

            if (sfid_required_entity_types.includes(entityTypeGuid)) {
                sfidInput.addClass("required");
                sfidRequiredAsterisk.show();
                sfidWrapper.removeClass('admin-form__sfid-wrapper--disabled');
                sfidInput.prop("disabled", false);
            } else {
                sfidInput.removeClass("required");
                sfidRequiredAsterisk.hide();
                sfidWrapper.addClass('admin-form__sfid-wrapper--disabled');
                sfidInput.prop("disabled", true);
            }

            if (entityTypeGuid === unverified_entity_type) {
                sfidInput.removeAttr('data-simple-api-validate');
                this.removeCometFormError('#' + sfidInputId);
                this.destroyValidationMessage('#' + sfidInputId);
                this.validateInput('#' + sfidInputId);
            } else {
                sfidInput.attr('data-simple-api-validate', 'True');
                if (entityTypeGuid === sale_entity_type) {
                    var value = sfidInput.val();

                    this.simpleApiValidate(value, sfidInputId, sfidInput.data('passAsParams'));
                }
            }
        },

        "submitTargetForm": function(e){
            e.currentTarget.form.submit();
        },

        "navigateBack": function(e){
            e.preventDefault();
            window.history.go(-1);
        },

        "formatCSVTranslatorJSON": function(e){
            var $target = this.$('#admin-form--csv-translator #translation-json');
            var targetValue = $target.val();
            if (targetValue && this.isValidJSON(targetValue)) {
                var inputJSON = JSON.parse(targetValue);
                var formattedJSON = JSON.stringify(inputJSON, null, 4);
                $target.val(formattedJSON);
            }
        },

        "selectAccessCheckbox": function(e){
            // looks for checked radio input and selects and disables adjacent checkbox input

            this.$('#user-school-associations input[type="checkbox"]').prop('disabled', false);

            var $currentRadioSelection = this.$('#user-school-associations input[type="radio"]:checked'),
                siteGuid = $currentRadioSelection.data('site-guid'),
                $adjacentAccessInput = this.$('#user-school-associations input[type="checkbox"][data-site-guid=' + siteGuid + ']'),
                adjacentAccessInputValue = $adjacentAccessInput.val();

            $adjacentAccessInput.prop('checked', true).prop('disabled', true);
            this.$('#user-school-associations #primary-selection').val(adjacentAccessInputValue);
        },

        "toggleSelect2": function(e){
            var $currentTarget = $(e.currentTarget),
                $currentTargetParent = $currentTarget.parent(),
                $select2 = $currentTargetParent.find("select"),
                $select2Container = $currentTargetParent.find(".select2-container");

            // select2 will automatically close on document click
            // so no need to manually close
            // stopPropagation is to prevent the click to open from being recognized as
            // a document click and therefore immediately closing it
            if (!$select2Container.hasClass("select2-container--open")) {
                $select2.select2('open');
                e.stopPropagation();
            }
        },

        "checkAll": function(e){
            // checks all checkbox inputs in specified container (specified with check-all-container data attrib) or .admin-form
            e.preventDefault();

            var $currentTarget = this.$(e.currentTarget);
            var containerName = $currentTarget.data('check-all-container');
            var $parentForm = $currentTarget.closest('.admin-form');
            if (containerName) {
                if ($currentTarget.closest(containerName).length) {
                    $currentTarget.closest(containerName).find('input[type="checkbox"]').prop('checked', true);
                } else {
                    $(containerName).find('input[type="checkbox"]').prop('checked', true);
                }
            } else {
                $parentForm.find('input[type="checkbox"]').prop('checked', true);
            }
        },

        "uncheckAll": function(e){
            // unchecks all checkbox inputs in specified container (specified with uncheck-all-container data attrib) or .admin-form
            e.preventDefault();

            var $currentTarget = this.$(e.currentTarget);
            var containerName = $currentTarget.data('uncheck-all-container');
            var $parentForm = $currentTarget.closest('.admin-form');

            if (containerName) {
                if ($currentTarget.closest(containerName).length) {
                    $currentTarget.closest(containerName).find('input[type="checkbox"]').prop('checked', false);
                } else {
                    $(containerName).find('input[type="checkbox"]').prop('checked', false);
                }
            } else {
                $parentForm.find('input[type="checkbox"]').prop('checked', false);
            }
        },

        "toggleElement": function(e){
            // toggle 'hidden' class based on checked state of current target
            var $currentTarget = this.$(e.currentTarget);
            var checked = $currentTarget.prop('checked');
            var elementToToggle = $currentTarget.data('toggle-element');
            var $elementToToggle = this.$(elementToToggle);

            if (checked) {
                $elementToToggle.removeClass('hidden');
            } else {
                $elementToToggle.addClass('hidden');
            }
        },

        "onClickAddClassSave": function(e){
            e.preventDefault();
            this.$('#admin-form--add-class #create_another').val('true');
            this.$('#admin-form--add-class').submit();
        },

        "capitalizeFirstLetter": function(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },

        "populateSelectInput": function(targetId, list, clearTarget){

            var $targetInput = this.$('#' + targetId);

            if (clearTarget) {
                $targetInput.empty();
            }

            _.each(list, function(i){
                var option = $('<option class="comet-form__select-option"></option>')
                    .attr('value', i.value)
                    .text(i.name)
                    .attr('selected', i.selected);
                $targetInput.append(option);
            });
        },

        "moveSelectOptions": function(e){
            var fromSelector = this.$(e.currentTarget).data('fromSelector');
            var toSelector = this.$(e.currentTarget).data('toSelector');
            var ignoreValue = this.$(e.currentTarget).data('ignoreValue');

            this.$(fromSelector)
                .find('option:selected')
                .filter(function(i, element){ return element.value !== ignoreValue; })
                .appendTo(toSelector);
        },

        "notUniq": function(list){
            // returns an array of non-unique items
            return _.reduce(list, function(duplicates, item, index, inputArray){
                if (inputArray.indexOf(item) !== index && duplicates.indexOf(item) === -1) {
                    duplicates.push(item);
                }
                return duplicates;
            }, []);
        },

        "isGuid": function(value){
            var pattern = new RegExp('^([a-z\\d]{8}-[a-z\\d]{4}-[a-z\\d]{4}-[a-z\\d]{4}-[a-z\\d]{12})$', 'i');
            var match = pattern.exec(value);
            return match !== null;
        },

        "copyToClipboard": function (string) {
            var textarea = document.createElement('textarea');
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.value = string;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        },

        "disableElement": function (target) {
            var $target = this.$(target);
            var elementType = $target.prop('nodeName');

            switch (elementType) {
                case 'BUTTON':
                    $target.addClass('comet-button--disabled');
                    $target.prop('disabled', true);
            }
        },

        "isValidJSON": function(str){
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                return false;
            }
        },

        "executeGUPMapping": function (e) {
            var $processNowButton = this.$(e.currentTarget);
            $processNowButton.addClass('comet-button--spinner');
            $processNowButton.addClass('comet-button--disabled');
            $processNowButton.prop('disabled', true);
            this.destroyBlockMessage();

            // this POST is dependent on 'edde/api_background/static/js/background.js'
            var accountGuid = initData.account_guid;
            var apiUrl = '/v1/services/google/mappings/' + accountGuid + '/execute';
            var apiToken = initData.execute_token;
            var postData = { 'debug_mode': false };
            var ajaxOptions = {
                'url': apiUrl,
                'type': 'POST',
                'dataType': 'json',
                'headers': { 'X-Token': apiToken },
                'data': JSON.stringify(postData),
                'contentType': 'application/json; charset=utf-8'
            };

            var deferred = api_background_helpers.ajax(ajaxOptions);
            deferred.fail(_.bind(function (xhr) {
                var resp = xhr.responseJSON || {};
                var message = resp.meta ? resp.meta.message : '';
                this.appendBlockMessage('.block-message-container', 'error', message);
            }, this));
            deferred.always(function () {
                $processNowButton.removeClass('comet-button--spinner');
                $processNowButton.removeClass('comet-button--disabled');
                $processNowButton.prop('disabled', false);
            });
            deferred.done(_.bind(function (data) {
                var studentUsersWritten = data.written_files.student.users_written;
                var teacherUsersWritten = data.written_files.teacher.users_written;
                var studentFilename = data.written_files.student.filename;
                var teacherFilename = data.written_files.teacher.filename;
                var studentSuccessMessage = studentUsersWritten + ' students saved. Filename: ' + studentFilename;
                var teacherSuccessMessage = teacherUsersWritten + ' teachers saved. Filename: ' + teacherFilename;
                this.appendBlockMessage('.block-message-container', 'success', studentSuccessMessage);
                this.appendBlockMessage('.block-message-container', 'success', teacherSuccessMessage);
            }, this));
        },

        "initializePromo": function(){

            if ($('.admin-promo-edit').length || $('.admin-promo-create').length){
                $('#start_date').datepicker({ 'dateFormat': 'yy-mm-dd' });
                $('#end_date').datepicker({ 'dateFormat': 'yy-mm-dd' });
            };

            if ($('.edit-remove-guid').length) {
                $('.edit-remove-guid').click(function(e){
                    e.preventDefault();
                    $(e.currentTarget).parent().remove();
                });
            }

            if ($('.admin-promo__aside').length) {
                this.initPromoFormAsideNav();
            }
        },

        "initPromoFormAsideNav": function() {
            window.addEventListener('scroll', _.throttle(function(e){
                var navLinks = $('.admin-promo__aside .comet-list-group__row-anchor'),
                    topMeasure = 240,
                    fromTop = window.scrollY,
                    $promoNav = $('.promo-nav'),
                    promoNavTop = $promoNav.offset().top;

                if (fromTop + 80 >= promoNavTop && fromTop >= topMeasure) {
                    $promoNav.addClass('float');
                } else {
                    $promoNav.removeClass('float');
                }

                $.each(navLinks, function(i, item){
                   var section = $(item.hash);
                   var sectionOffset = $(section).offset();

                   if (sectionOffset.top <= fromTop + topMeasure && sectionOffset.top + section.outerHeight() >= fromTop + topMeasure) {
                       $(item).parent().addClass('comet-list-group__row--selected');
                    } else {
                        $(item).parent().removeClass('comet-list-group__row--selected');
                    }
                });

            }, 150));
        },

        "adminPromoFormValidation": function() {
            var promoInputFields = ['#promo_name', '#asset_id', '#public_title', '#public_subtitle', '#public_description', '#start_date', '#end_date'],
                isWebSiteLocationNotSelected = $('input[name=website_locations]:checked').length === 0;

            var isRequiredFieldEmpty = _.some(promoInputFields, function(id){
                return !this.$(id).val();
            }, this);

            if (isWebSiteLocationNotSelected) {
                $('#area').addClass('comet-form--error');
            } else {
                $('#area').removeClass('comet-form--error');
            }

            _.each(promoInputFields, function(id){
                var input = $(id);
                if (!input.val()){
                    this.addCometFormError(input);
                    this.invalidateInput(input);
                    this.appendValidationMessage("" + id, 'invalid', 'This field is required');
                } else {
                    input.siblings('.admin-validation-message').remove();
                    this.removeCometFormError(input);
                }
            }, this);

            return {
                'isRequiredFieldEmpty': isRequiredFieldEmpty,
                'isWebSiteLocationNotSelected': isWebSiteLocationNotSelected,
            };
        },

        "updatePromo": function(e) {
            e.preventDefault();
            var $updateForm = $('#edit_promo'),
                formRequiredInputs = this.adminPromoFormValidation();

            this.submitPromoForm($updateForm, formRequiredInputs);
        },

        "createPromo": function(e){
            e.preventDefault();
            var $createForm = $('#create_promo'),
                formRequiredInputs = this.adminPromoFormValidation();

            this.submitPromoForm($createForm, formRequiredInputs);
        },

        "submitPromoForm": function($form, formRequiredInputs) {
            if (formRequiredInputs.isRequiredFieldEmpty || formRequiredInputs.isWebSiteLocationNotSelected){
                this.appendAdminPromoBlockMessage('.admin-promo__message', 'error', 'Please provide the required fields');
            } else {
                $form.submit();
            }
        },

        "openPromoUploadModal": function(e) {
            var $currentTarget = $(e.currentTarget);
            var baseUrl = '/apiproxy/v1/promos/banner_image';
            var hasImage = $currentTarget.data('has-image') === 'True';

            this.modal && this.modal.destroy();
            this.modal = new UploadPromoImageModal({
                "model": new Backbone.Model({
                    'baseUrl': baseUrl,
                    'bannerId': $('#banner_id').val(),
                    'promoId': $currentTarget.data('promo-id'),
                    'token': $currentTarget.data('token'),
                    'hasImage': hasImage,
                })
            });
            this.listenTo(this.modal, 'deleteSuccess', function () {
                // Clear out existing banner id when image is deleted
                this.$('#banner_id').val('').prop('disabled', false);
            });
            this.listenTo(this.modal, 'uploadSuccess', _.bind(function (resp) {
                var $image = $('<img />').attr('src', resp.url);
                this.$('#banner-image').html($image);
                this.$('#promo-banner-requires-image-message').remove();
                this.$('#banner_id').val(resp.id).prop('disabled', false);
                this.$('#promo-form-upload-image').attr('data-banner-id', resp.id);
                this.$('#banner_bg_color_1').prop('disabled', false);
                this.$('#upload-promo-image-error').addClass('hidden');

                this.modal.destroy();
            }, this));
            this.listenTo(this.modal, 'uploadError', _.bind(function (err) {
                $('#upload-promo-image-error').removeClass('hidden');
            }));

            $('body').append(this.modal.render().$el);
        },

        "getAssetGuidData": function(e){
            e.preventDefault();
            var id = $('#asset_id').val().trim(),
                url = $('.promo-form').data('api-url'),
                $promoImageContainer = $('.promo-form__asset-image');

            // Clear old image or error message
            $promoImageContainer.addClass('promo-form__asset-image--loading')
                .find('p, img').remove();

            if (id && this.isGuid(id)) {
                $.ajax({
                    'type': 'GET',
                    'url': url + '/v1/assets/' + id + '?override_restrictions=true',
                    'crossDomain': true,
                    'xhrFields': {
                        'withCredentials': true
                    }
                })
                .done(_.bind(function (resp) {
                    var asset = resp.asset,
                        thumbPath = 'https://d1m0scxbrw6oep.cloudfront.net/thumbnails/' + asset.id + '-small';

                    $('#public_title').val(asset.title);
                    $('#public_description').val(asset.description);

                    $promoImageContainer.removeClass('promo-form__asset-image--loading');
                    $promoImageContainer.append('<img id="thumbnail" src="' + thumbPath + '">');

                    if (asset.grades.length){
                        this.checkGradesCheckboxes(asset.grades);
                    }
                }, this))
                .fail(_.bind(function (jqxhr, textStatus, error) {
                    var message = 'Asset GUID Request Failed: ' + jqxhr.responseJSON.meta.message;
                    window.console.log(error);
                    $promoImageContainer.removeClass('promo-form__asset-image--loading');
                    $promoImageContainer.append('<p>Error! No Image</p>');
                    this.appendAdminPromoBlockMessage('.admin-promo__message', textStatus, message);
                }, this));

            } else {
                $('#asset_id').select();
                var message = 'Invalid Guid: Please Provide a Valid Asset GUID';
                $promoImageContainer.removeClass('promo-form__asset-image--loading');
                this.appendAdminPromoBlockMessage('.admin-promo__message', 'error', message);
            }
        },

        "checkGradesCheckboxes": function(grades){
            var map_band = {};

            $.each(grades, function (i, grade) {
                if (grade.abbreviation && !map_band[grade.grade_band]) {
                    map_band[grade.grade_band] = true;
                    $('#grade_band_' + grade.grade_band).prop('checked', true);
                }

            });
        },

        "archivePromo": function(e){
            e.preventDefault();
            var promoId = $(e.currentTarget).data("promo-id"),
                archiveToken = $('.admin-promo-index').data('archive-token');

            $.ajax({
                'type': 'POST',
                'url': '/v1/promos/archive',
                'data': {'promo_id': promoId, 'token': archiveToken},
                'crossDomain': true,
                'xhrFields': {
                    'withCredentials': true
                }
            })
            .done(_.bind(function (resp) {
                this.showPromoModal('success', 'Highlight archived successfully', false);
                $(e.currentTarget).parents('.comet-data-table__row').remove();
            }, this))
            .fail(_.bind(function (jqxhr, textStatus, error) {
                var message = 'Request Failed: ' + jqxhr.responseJSON.meta.message;
                    window.console.log(error);
                    this.appendAdminPromoBlockMessage('.admin-promo__message', textStatus, message);
            }, this));

        },

        "initializePreview": function(){
            var highlightType = this.$('#highlight_type').find(':selected').text();

            if (highlightType !== 'Banner') {
                $('#banner-preview-container').hide();
                return;
            }

            //grab values from form inputs to populate component
            var image = this.$('#banner-image').find('img').prop('src');
            var headline = this.$('#public_title').val();
            var description = this.$('#public_description').val();
            var renderWithGradient = this.$('#gradient-radio').is(':checked');
            var gradientStart = null;
            var gradientEnd = null;
            var hideTitleCard = this.$('#hide_public_description').is(':checked');
            var displayThumbnailOnly = this.$('#display_thumbnail_only').is(':checked');
            var bannerButtonText = this.$('#banner_button_text').val();
            var hasButton = bannerButtonText.length > 0;

            if (renderWithGradient) {
                gradientStart = "#" + this.$('#banner_bg_color_2').val();
                gradientEnd = "#" + this.$('#banner_bg_color_1').val();
            }

            if (hideTitleCard) {
                description = null;
            }

            if (displayThumbnailOnly) {
                description = null;
                headline = null;
            }

            this.preview = mountVueComponent(
                NebulaComponents.NebulaBanner,
                '#banner-preview-target',
                {
                    "contentInset": true,
                    "headline": headline,
                    "description": description,
                    "image": image,
                    "useFloatingImage": true,
                    "dismissable": true,
                    "buttons": hasButton,
                    "gradient": renderWithGradient,
                    "gradientStart": gradientStart,
                    "gradientEnd": gradientEnd,
                    "type": "text-left",
                },
                {
                    "button-area": function() {
                        return Vue.h(NebulaComponents.NebulaButton, {
                            "text": bannerButtonText
                        });
                    }
                }
            );
        },

        "initializePromoPage": function() {
            this.updatePromoFormControls();
            this.onTogglePromoGradient();
        },

        "updatePromoFormControls": function(){
            var highlightType = this.$('#highlight_type').find(':selected').text();
            var accountInput = this.$('#account-guid');
            var siteInput = this.$('#site-guid');
            var bannerButtonLabelInput = this.$('#button_label_field_group');
            var gradeCheckboxes = this.$('[name="grade_bands"]');
            var subjectCheckboxes = this.$('[name="subjects"]');
            var interestsCheckboxes = this.$('[name="interests"]');
            var uploadImageButton = this.$('#promo-form-upload-image');
            var bannerUserInstructions = this.$('#banner-user-instructions');
            var bannerImage = this.$('#banner-image');
            var bannerBackgroundOptions = this.$('#banner-background-options');
            var bannerPreviewSection = this.$('#banner-preview-container');

            switch (highlightType) {
                case 'Banner':
                    accountInput.prop('disabled', true);
                    siteInput.prop('disabled', true);
                    gradeCheckboxes.prop('disabled', true);
                    subjectCheckboxes.prop('disabled', true);
                    interestsCheckboxes.prop('disabled', true);

                    bannerPreviewSection.show();
                    bannerBackgroundOptions.show();
                    bannerButtonLabelInput.show();
                    bannerUserInstructions.show();
                    bannerImage.show();
                    uploadImageButton.show();
                    break;
                case 'Provisioned':
                    accountInput.prop('disabled', true);
                    siteInput.prop('disabled', true);
                    gradeCheckboxes.prop('disabled', true);
                    subjectCheckboxes.prop('disabled', false);
                    interestsCheckboxes.prop('disabled', false);

                    bannerPreviewSection.hide();
                    bannerBackgroundOptions.hide();
                    bannerButtonLabelInput.hide();
                    bannerUserInstructions.hide();
                    bannerImage.hide();
                    uploadImageButton.hide();
                    break;
                case 'Recommended':
                    accountInput.prop('disabled', true);
                    siteInput.prop('disabled', true);
                    gradeCheckboxes.prop('disabled', false);
                    subjectCheckboxes.prop('disabled', true);
                    interestsCheckboxes.prop('disabled', true);

                    bannerPreviewSection.hide();
                    bannerBackgroundOptions.hide();
                    bannerButtonLabelInput.hide();
                    bannerUserInstructions.hide();
                    bannerImage.hide();
                    uploadImageButton.hide();
                    break;
            }
        },

        "onTogglePromoGradient": function(){
            var isGradientChecked = this.$('#gradient-radio').is(':checked');
            if (isGradientChecked) {
                this.$('#custom-gradient-fieldset').removeClass('nebula-group--hidden');
                this.$('#radio-gradient-options').removeClass('nebula-group--hidden');
                this.$('#banner_bg_color_2').prop('disabled', false);
                var $checked = this.$("input[type='radio'][name='promo-bg-gradient']:checked");
                if ($checked.length) {
                    $checked.trigger("change");
                } else {
                    var $firstGradientRadio = this.$("input[type='radio'][name='promo-bg-gradient']").first();
                    $firstGradientRadio.prop("checked", true).trigger("change");
                }
            } else {
                this.$('#custom-gradient-fieldset').addClass('nebula-group--hidden');
                this.$('#radio-gradient-options').addClass('nebula-group--hidden');
                this.$('#banner_bg_color_1').val('FFFFFF');
                this.$('#banner_bg_color_2').val('FFFFFF');
            }
        },

        "onSelectPromoGradient": function(e) {
            var isCustomGradientChecked = this.$('#promo-bg-custom').is(':checked');
            if (isCustomGradientChecked) {
                this.$('#banner_bg_color_1').removeProp('readonly');
                this.$('#banner_bg_color_2').removeProp('readonly');
            } else {
                var $currentTarget = $(e.currentTarget);
                this.$('#banner_bg_color_1').prop('readonly', 'readonly');
                this.$('#banner_bg_color_2').prop('readonly', 'readonly');
                this.$('#banner_bg_color_1').val($currentTarget.data('color1'));
                this.$('#banner_bg_color_2').val($currentTarget.data('color2'));
            }
        },

        "scrollToView": function($el){
            $([document.documentElement, document.body]).animate({
                'scrollTop': $($el).offset().top
            }, 700);
        },

        "showPromoModal": function(type, message, showBackToHome){
            this.modal && this.modal.destroy();
            this.modal = new PromoModal({
                    "model": new Backbone.Model({
                        "modalText": message,
                        "type": type,
                        "showBackToHome": showBackToHome,
                })
            });

            $('body').append(this.modal.render().$el);
        },

        "appendAdminPromoBlockMessage": function(container, statusText, messageText){
            this.appendBlockMessage(container, statusText, messageText);
            this.scrollToView($(container));
            setTimeout(_.bind(function(){
                this.destroyBlockMessage(messageText);
            }, this), 5000);
        },

        "addGuid": function(type, $container, url) {
            $.ajax({
                'type': 'GET',
                'url': url,
                'crossDomain': true,
                'xhrFields': {
                    'withCredentials': true
                }
            })
            .done(_.bind(function (resp) {
                var name = resp[type].name,
                    id = resp[type].id,
                    newInput = new AudienceGuid({
                        'model': new Backbone.Model({
                            'type': type,
                            'name': name,
                            'guid': id,
                        })
                });

                $container.append(newInput.render().$el);

            }, this))
            .fail(_.bind(function (jqxhr, textStatus, error) {
                var message = 'Request Failed: ' + jqxhr.responseJSON.meta.message;
                    window.console.log(error);
                    this.appendAdminPromoBlockMessage('.admin-promo__message', textStatus, message);
            }, this))
            .always(function(){
                $('#' + type + '-guid').val("");
            });
        },

        "addAccountGuid": function(e) {
            e.preventDefault();
            var $accountListContainer = $('.account-list'),
                accountGuid = $('#account-guid').val(),
                url = '/v1/accounts/' + accountGuid;

            this.addGuid('account', $accountListContainer, url);
            this.disableBtn($(e.currentTarget), true);
        },

        "addSiteGuid": function(e) {
            e.preventDefault();
            var $siteListContainer = $('.site-list'),
            siteGuid = $('#site-guid').val(),
            url = '/v1/sites/' + siteGuid;

            this.addGuid('site', $siteListContainer, url);
            this.disableBtn($(e.currentTarget), true);
        },

        "disableBtnOnInvalidGuid": _.debounce(function(e){
            var value = $(e.currentTarget).val();
            var $btn = $(e.currentTarget).siblings('button');
            if (this.isGuid(value)){
                this.disableBtn($btn, false);
            } else {
                this.disableBtn($btn, true);
            }
        }, 50),

        "disableBtn": function($el, value) {
            if (value){
                $el.prop('disabled', value);
                $el.addClass('comet-button--disabled');
            } else {
                $el.prop('disabled', value);
                $el.removeClass('comet-button--disabled');
            }
        },

        // TODO: ABSTRACT ME
        "updateBulkIssueQrCodeMenuItems": function(needsQr) {
            var $classroomActionsMenu = this.$('.classroom-details__dropdown'),
                $setItem = $classroomActionsMenu.find('.classroom-dropdown__action-bulk_set_qr'),
                $resetItem = $classroomActionsMenu.find('.classroom-dropdown__action-bulk_reset_qr'),
                $needAssistIndicator = this.$('.needs-assistance-btn.needs-assistance-popover-trigger'),
                classroomData = $classroomActionsMenu.data('classroom'),
                needsPw = classroomData.need_assistance;

            $resetItem.toggleClass('bulk-set-qr-form__elem--hidden', needsQr);
            $setItem.toggleClass('bulk-set-qr-form__elem--hidden', !needsQr);
            $needAssistIndicator.toggleClass('bulk-set-qr-form__elem--hidden', _.any([!needsQr, !needsPw]));

            classroomData.need_qr_auth = needsQr;
            $classroomActionsMenu.data('classroom', classroomData);
        },

        "generateQRCodes": function(e) {
            var selectedQrStudents = this.model.get('selectedQrStudents');
            var classroom = this.model.get('classroom');
            var site = this.model.get('site');
            var account = this.model.get('account');

            // add state to back button after user is shown layout options.
            this.$('.qr-back-btn').data('status', 'download-needed');

            // btn is dsiabled if no studet is selected, but its okay to check again.
            if (selectedQrStudents.length) {
                this.modal && this.modal.destroy();
                this.modal = new BulkSetQRModalGenerate({
                    "model": new Backbone.Model({
                        "student": this.model.get('student'),
                        "students": selectedQrStudents,
                        "classroom": classroom,
                        "site": site,
                        "account": account,
                        "isAdmin": this.model.get('isAdmin'),
                        "nextURL": app.get('initData', {}).get('next_url'),
                        "searchTeachersToken": app.initData.get("tokens").search_teachers,
                    })
                });
                $('body').append(this.modal.render().$el);
            }
            return;
        },

        // if bulk selection is true get the students from this.model.get('selectedQrStudents');
        // else collect all students whos' boxed are checked
        "getSelectedStudents": function() {
            var checkedStudents = [],
                students = this.model.get('students');

            if (this.isBulkSelection) {
                checkedStudents = this.model.get('selectedQrStudents');
            } else {
                var $inputsChecked = this.$('.students-qr-table-body .comet-form__checkbox-input:checked');
                $inputsChecked.each(function (i, $stdtEl) {
                    var student = _.find(students, function(stdt) {
                        return stdt.user_id === $stdtEl.dataset.id;
                    });
                    checkedStudents.push(student);
                });
            }
            return checkedStudents;
        },

         // give room for random selection or bulk selection
         "setBulkSelectionMode": function() {
            this.isBulkSelection = false;
            this.updateBulkSelectedStudents(true, this.getSelectedStudents());
        },

        "toggleCheckAll": function(e) {
            e.preventDefault();
            var students = this.model.get('students');
            $('#check-student-indicator').is(':checked')
                ? this.updateBulkSelectedStudents(true, students)
                : this.updateBulkSelectedStudents(false, students);
        },

        "handleSelectAll": function(e) {
            e.preventDefault();

            var students = this.model.get('students'),
                $checkIndicator = $('#check-student-indicator'),
                state = $checkIndicator.data('state'),
                isChecked = $checkIndicator.is(':checked');

            if ($checkIndicator.is(':checked')) {
                this.updateBulkSelectedStudents(true, students);
                $checkIndicator.prop('checked', true);
            } else {
                this.updateBulkSelectedStudents(false, students);
            }

            switch (state) {
                case 'selection':
                    this.updateBulkSelectedStudents(true, students);
                    $checkIndicator.prop('checked', true);
                    break;
                case 'none':
                case 'all':
                default:
                    this.updateBulkSelectedStudents(isChecked, students);
                    $checkIndicator.prop('checked', isChecked);
            }
        },

        "clearSelection": function() {
            this.updateBulkSelectedStudents(false, []);
        },

        "updateStudentSelectionState": function(selectAll, selectSingle) {
            var $checkbox = $('#check-student-indicator'),
                $container = $('label[for=check-student-indicator]'),
                single = selectSingle ? 'selection' : '',
                modifier = selectAll ? 'all' : single,
                targetElClass = 'comet-form__checkbox-checked-icon--' + modifier;

            $checkbox.data('state', modifier);

            if (!selectAll || !selectSingle) {
                $checkbox.prop('checked', false);
                $checkbox.data('state', 'none');
            }

            // need to use vanilla js for svgs
            $.each($container.find('.comet-form__checkbox-checked-icon'), function(_, el) {
                var classList = el.classList;

                if (classList.contains(targetElClass)) {
                    el.classList.remove('bulk-qr-form__elem--hidden');
                } else {
                    el.classList.add('bulk-qr-form__elem--hidden');
                }

                if (modifier === 'selection') {
                    $('#check-student-indicator').prop('checked', true);
                }
            });
        },

        "handleSelectStudents": function(e) {
            e.preventDefault();

            var $el = $(e.target),
                studentSelection = $el.closest('li').data('selection'),
                students = this.model.get('students') || [];

            switch (studentSelection) {
                case 'all':
                    this.updateBulkSelectedStudents(true, students); // select all students
                    break;
                case 'none':
                    this.updateBulkSelectedStudents(false, students); // select No students
                    break;
                case 'unissued':
                    this.updateBulkSelectedStudents(true,
                        students.filter(function(student) {
                            return !student.qr_auth;
                        })
                    );
                    break;
                case 'expired':
                    var now = moment();

                    this.updateBulkSelectedStudents(true,
                        students.filter(function(student) {
                            return !student.qr_auth ? false :
                                now > moment(student.qr_auth.expire_date_utc);
                        })
                    );
                    break;
                default:
                    // pass
            }
        },

        // updates the UI when a group of students are selected
        "updateBulkSelectedStudents": function(isSelected, students) {
            var $checkIndicator = this.$('#check-student-indicator');
            var $studentCountMessage = this.$('.qr-code__count');

            // reset all first
            this.$('.comet-data-table__row input').prop('checked', false);

            // if true check all students passed in otherwise uncheck all
            if (isSelected && students.length) {
                students.forEach(_.bind(function(student){
                    var $studentEl = this.$('#student-id-' + student.user_id);
                    $studentEl.find('input').prop('checked', true);
                    $checkIndicator.prop('checked', true);
                }, this));
                $studentCountMessage.removeClass('bulk-qr-form__elem--hidden');
                $studentCountMessage.find('p').first().text(feedBackMessage({ "std_length": students.length, "message": "select_message" }));
                this.activateQrGenerateBtn(true);
                this.model.set("selectedQrStudents", students);
                // this is a bulk selection (student can also be selected individually)
                this.isBulkSelection = true;
            } else {
                students.forEach(_.bind(function(student){
                    var $studentEl = this.$('#student-id-' + student.user_id);
                    $studentEl.find('input').prop('checked', false);
                    $checkIndicator.prop('checked', false);
                }, this));
                $studentCountMessage.addClass('bulk-qr-form__elem--hidden');
                this.activateQrGenerateBtn(false);
                this.model.set("selectedQrStudents", []);
                this.isBulkSelection = false;
            }

            // if no students are selected, clear icons.
            if (!isSelected) {
                this.updateStudentSelectionState();
                return;
            }

            var totalStudents = (this.model.get('students') || []).length,
                selectionLength = students.length,
                isAll = totalStudents === selectionLength,
                isSome = selectionLength > 0;

            // if all students are select by select all or by selecting all
            //  students individually, lets treat this as the same state.
            if (isAll) {
                this.updateStudentSelectionState(true);
                $('#check-student-indicator').prop('checked', true);
                return;
            }

            // if some are selected, lets update state, but indicate its only
            //  partial selection.
            if (isSome) {
                this.updateStudentSelectionState(null, true);
            } else {
                this.updateStudentSelectionState();
            }
        },

        // Generate button is only enabled if and at least one student is selected
        "activateQrGenerateBtn": function(isActive) {
            var $btn = this.$('#bulk_qr_generate');
            $btn.prop('disabled', !isActive);
            !isActive ? $btn.addClass('comet-button--disabled') : $btn.removeClass('comet-button--disabled');
        },

        "confirmToExitQr": function(e) {
            var $target = $(e.target);

            // if the user is on the download page, popup a modal to show a warning message that they will loose all generated codes
            // checking for download button on the page, otherwise, just route them back to the previous url
            if (this.$('#bulk_qr_distribute').length > 0 && $target.data('status') === 'download-needed') {
                this.modal && this.modal.destroy();
                this.modal = new BulkSetQRModalGenerate({
                    "model": new Backbone.Model({
                        "allowClose": true,
                        "sureToExit": true,
                        "nextUrl": $target.data('exitUrl'),
                    })
                });
                $('body').append(this.modal.render().$el);
            } else {
                window.location.href = $target.data('exitUrl');
            }
        },

        "enableContinueButton": function() {
            $('.onboarding-methods__footer .nebula-button').removeAttr('disabled');
        },

        "submitSelectedMethod": function() {
            $('#onboarding-methods').submit();
        },

        "enableSelectSSOContinueButton": function(e) {
            var isSelected = $('.onboard-select-sso__input:checked').length >= 1;

            if (isSelected) {
                $('.onboard-select-sso__continue').prop('disabled', false);
            }
        },

        "submitServiceDetails": function() {
            $('#service-details-form').submit();
        },

        "enableContinueToMapSchoolButton": function() {
            var count = 0;
            $('.comet-form__input').each(function(input) {
                if ($(this).val() !== "") {
                    count++;
                }
            });
            if (count === $('.comet-form__input').length) {
                $('.service-details__footer .nebula-button').removeAttr('disabled');
            } else {
                $('.service-details__footer .nebula-button').attr('disabled', true);
            }
        },

        "validateSubdomainEntry": function(event) {
            var subdomainInputValue = $('#subdomain-0').val();

            if (!subdomainInputValue) {
                event.preventDefault();
                $('.add-subdomain__field-group').addClass('comet-form--error');
            } else {
                $('.add-subdomain__field-group').removeClass('comet-form--error');
            }
        },

        "closeBlockMessage": function () {
            this.toggleOnboardingBlockMessage();
        },

        "showOnboardingBlockMessage": function() {
            _.delay(this.toggleOnboardingBlockMessage, 1000);
        },

        "toggleOnboardingBlockMessage": function() {
            $('.admin-onboarding__block-message').toggleClass('admin-onboarding__block-message--visible');
        },

        "handleOnboardSelectSSOFormSubmit": function(e) {
            e.preventDefault();

            $('.onboard-select-sso__form').submit();
        },

        "onCleverSchoolSelected": function(e) {
            var $el = $(e.target),
                $row = $el.closest("tr"),
                $tbody = $row.closest("tbody"),
                val = $el.val();

            if (val) {
                var $clonedRow = $row.remove().clone();

                // move from unmapped to mapped.
                $('.admin-onboarding-map-schools__mapped')
                    .find('.comet-data-table tbody')
                    .append($clonedRow);

                // make sure we have value set
                $clonedRow.find('option[value=' + val + ']')
                    .attr('selected', true);

                // if we have already mapped all schooles, lets remove the action warning,
                //  show success message, and enable the submit btn.
                if ($tbody.find('tr').length === 0) {
                    $tbody.closest('table')
                          .addClass('admin-onboarding-map-schools--hidden');
                    $('.admin-onboarding-map-schools__actions--unmapped-required, .admin-onboarding-map-schools__unmapped-instruction')
                        .addClass('admin-onboarding-map-schools--hidden');
                    $('.admin-onboarding-map-schools__actions--unmapped-success')
                        .removeClass('admin-onboarding-map-schools--hidden');

                    $('.admin-onboarding__footer--map-clever')
                        .find('.onboarding-footer__button-container')
                        .find('.nebula-button--square')
                        .attr('disabled', false);
                }
            }
        },

        "submitCleverSchools": function(e) {
            $('.admin-form--edit-clever-school-ids').submit();
        },

        "toggleCleverPopulateAccount": function(e) {
            $('.onboarding-clever__continue').attr('disabled', !e.target.value);
        },

        "submitCleverSSOConfig": function(e) {
            $('.admin-onboarding-form.configure-clever')
                .submit();
        },

        "enableClasslinkContinueButton": function(e) {
            var $section = $('.onboarding-classlink'),
                $tenantInput = $section.find('#tenant-id'),
                $selectedConfigEmail = $section.find('input[name=email_use]:checked');

            $('.onboarding-classlink__continue')
                .attr('disabled', !($selectedConfigEmail.val() && $tenantInput.val().length > 0));
        },

        // 2022 School ID Mapping
        "toggleSelectDropdownState": function($selectElement) {
            $selectElement.toggleClass('nebula-dropdown--open');
            $selectElement.removeClass('school-select--failure');
        },

        "toggleAllSelectDropdownState": function(event) {
            var $openedSelectDropdown = $('.school-select.nebula-dropdown--open'),
                $target = $(event.target),
                hasDropdownSearchInputId = $target.is('#school-dropdown-search-input'),
                $parentElement = $(event.target.offsetParent);

            // First close any open Select Dropdown elements
            if ($openedSelectDropdown.length && !hasDropdownSearchInputId) {
                this.toggleSelectDropdownState($openedSelectDropdown);
            }

            // Then open selected Dropdown
            if ($parentElement.length && $parentElement.hasClass('school-select')) {
                this.toggleSelectDropdownState($parentElement);
                this.renderDESitesList($parentElement);
            }
        },

        "renderDESitesList": function(parentElement) {
            var parentDataSet = parentElement[0].dataset;
            var hasVueDropdownRendered = $('#school-list-dropdown-' + parentDataSet.cleverId + '> .school-dropdown').length;

            if (!hasVueDropdownRendered) {
                var anchorEl = document.getElementById('school-list-dropdown-' + parentDataSet.cleverId);
                anchorEl.innerHTML = '<div class="school-dropdown-render"></div>';

                var data = {
                    'sites': initData.sites,
                    'mappedSchoolGuid': parentDataSet.mappedSchoolGuid,
                    'accountId': parentDataSet.accountId,
                    'cleverId': parentDataSet.cleverId
                };

                CleverIDMappingDropdown.renderSiteList(data);
            }
        },

        "postSelectedSchoolForMatching": function(e) {
            var currentTarget = $(e.currentTarget),
                selectElement = currentTarget.closest('.school-select'),
                siteData = CleverIDMappingDropdown.selectedSiteData;

            selectElement.toggleClass('school-select--loading');

            var jsonObject = JSON.stringify({
                "provider_id": siteData.cleverId,
                "site_guid": siteData.site_guid || "",
                "account_guid": siteData.accountId,
            });

            $.ajax({
                "type": "PATCH",
                "url": "/apiproxy/v1/sites/update-" + initData.provider_name.toLowerCase() + "-id",
                "dataType": "json",
                "data": jsonObject,
                "contentType": "application/json; charset=utf-8",
                "success": _.bind(function(resp) {
                    var hasSchoolGuid = !!siteData.site_guid;
                    this.setupSelectButtonText(selectElement, siteData);
                    this.setupToastMessage(resp, siteData.site_guid, selectElement);
                    this.updateCount(hasSchoolGuid);
                }, this),
                "error": _.bind(function(resp) {
                    this.setupToastMessage(resp, siteData.site_guid, selectElement);
                }, this),
            });
        },

        "updateCount": function(isMapping) {
            this.$('.js-admin-count--unmapped').html(function(i, val) { return isMapping ? --val : ++val; });
            this.$('.js-admin-count--mapped').html(function(i, val) { return isMapping ? ++val : --val; });
        },

        "setupToastMessage": function(resp, schoolGuid, selectElement) {
            selectElement.removeClass('school-select--success school-select--error');

            var responseJSON = resp.responseJSON,
                isSuccessful = resp.meta && resp.meta.status_code === 200,
                statusText = isSuccessful ? 'Auto saved!' : 'Error: Unsaved Changes.',
                text = !schoolGuid ? 'Unmapped Discovery Education School ID' : statusText,
                type = isSuccessful ? 'success' : 'error',
                message = {
                    "className": "school-id-mapping--message",
                    "icon": isSuccessful ? "circle-check" : "circle-x",
                    "id": schoolGuid,
                    "isSmall": true,
                    "setFadeOutTimerTo": 2000,
                    "type": type,
                    "text": text,
                };

            if (type === 'error') {
                message.title = text;
                message.text = responseJSON.meta.message;
                message.disableFadeout = true;
                message.content = {
                    "title": 'request id: ',
                    "action": responseJSON.meta.request_id,
                };
            }

            selectElement.addClass('school-select--' + type);
            selectElement.toggleClass('school-select--loading');

            AdminToastMessage.appendNewToastMessage(message);

        },

        "setupSelectButtonText": function(selectElement, dataset) {
            var schoolLabel = selectElement.find('.school-select__text--label'),
                optionNone = selectElement.find('.school-dropdown-item__button--none'),
                schoolNameElement = selectElement.find('.school-select__text--name'),
                schoolGuidElement = selectElement.find('.school-select__text--guid');

            if (dataset.site_guid) {
                schoolLabel.html('');
                schoolNameElement.html(dataset.name);
                schoolGuidElement.html(dataset.site_guid);
                optionNone.attr('aria-disabled', false);
            } else {
                schoolLabel.html('Unmapped - Select School');
                schoolNameElement.html('');
                schoolGuidElement.html('');
                optionNone.attr('aria-disabled', true);
            }
        },

        "initializeCleverIdMappingPagination": function() {
            var SkipLimitGenerator = NebulaComponents.NebulaPaginationLinkGenerators.SkipLimitGenerator;
            var pagination = initData.pagination;

            var linkGenerator = new SkipLimitGenerator({
                "limit": pagination.limit,
                "skip": pagination.skip,
                "totalRecords": pagination.total_recs
            });

            this.cleverPagination = mountVueComponent(
                NebulaComponents.NebulaPagination,
                '#clever-id-pagination',
                {
                    "class": "admin-pagination",
                    "linkGenerator": linkGenerator,
                    "onSelectPage": _.bind(this.updatePagination, this)
                }
            );
        },

        "updatePagination": function(page) {
            var searchParams = new URLSearchParams(window.location.search),
                perPageSelected = $('#admin-pages-select').val(),
                requestedPage = typeof page === 'number' ? page : initData.pagination.current_page;

            searchParams.set("is_mapped", initData.is_mapped);
            searchParams.set("page", requestedPage);
            searchParams.set("per_page", perPageSelected);

            window.location.search = searchParams.toString();

        },

        // Manage Users Refresh page
        "vueUserImport": {},
        "vueUserManage": {},
        "propsData": {},
        "managePropsData": {},

        "initializeManageUsersRefresh": function() {
            this.getUploadedFiles().then(_.bind(function(resp) {
                this.propsData = Vue.reactive({
                    "uploadedFiles": resp.refresh_files,
                });
                this.mountUsersRefreshAccordion();
            }, this)).fail(_.bind(function(err) {
                window.console.error('err: ', err);
                this.appendUserToastMessageError({
                    "data": err.responseJSON,
                });
            }, this));
        },

        "getUploadedFiles": function() {
            var accountGuid = initData.account_guid;
            var url = "/apiproxy/v1/accounts/" + accountGuid + "/get-refresh-files";
            var refreshType = initData.refresh_type;

            url = refreshType ? url + "?type=" + refreshType : url;

            return $.ajax({
                "method": "GET",
                "url": url,
                "dataType": "json",
                "contentType": "application/json; charset=utf-8",
            });

        },

        "mountAssetExclusions": function() {
            var accountGuid = $("#admin-asset-exclusions-app").attr('data-account-guid');
            var siteGuid = $("#admin-asset-exclusions-app").attr('data-site-guid');

            this.assetExclusionsVue = mountVueComponent(
                AssetManagementTool,
                "#admin-asset-exclusions-app",
                {
                    "accountGuid": accountGuid,
                    "siteGuid": siteGuid
                }
            );
        },

        "mountGLQ": function() {
            this.GLQVue = mountVueComponent(
                GlobalLicenseQueue,
                "#admin-glq-app"
            );
        },

        "mountUsersRefreshAccordion": function() {
            this.propsData.onManageUsers = _.bind(this.displayManageUsersView, this);
            this.propsData.onAppendToastMessageError = _.bind(this.appendUserToastMessageError, this);
            this.propsData.onAppendToastMessageSuccess = _.bind(this.appendUserToastMessageSuccess, this);

            this.vueUserImport = mountVueComponent(
                PlatformComponents.UsersImportAccordion,
                "#vue-users-import",
                this.propsData
            );

            this.managePropsData = Vue.reactive({
                "fileKey": 0,
                "fileType": "user",
                "districtName": initData.district_name,
                "onDiscardedFile": _.bind(this.updateImportList, this),
                "onAppendToastMessageError": _.bind(this.appendUserToastMessageError, this)
            });

            this.vueUserManage = mountVueComponent(
                PlatformComponents.UsersManageAccordion,
                "#vue-users-manage",
                this.managePropsData
            );
        },

        "appendUserToastMessageSuccess": function(message) {
            message = {
                "className": "user-refresh-error--message",
                "icon": "circle-check",
                "id": "user-refresh-success-" + message.id,
                "isSmall": true,
                "type": "success",
                "title": message.message
            };
            AdminToastMessage.appendNewToastMessage(message);
        },

        "appendUserToastMessageError": function(message) {
            message = {
                "className": "user-refresh-error--message",
                "icon": "circle-x",
                "id": "user-refresh-error-" + message.data.meta.request_id,
                "isSmall": true,
                "type": "error",
                "content": {
                    "title": "request id: " + message.data.meta.request_id + '.',
                    "action": message.data.meta.message,
                },
            };
            AdminToastMessage.appendNewToastMessage(message);
        },

        "displayManageUsersView": function(data) {
            this.managePropsData.fileKey = data.fileKey;
            this.managePropsData.fileType = data.fileType;
        },

        "updateImportList": function(fileKey) {
            this.propsData.uploadedFiles = this.propsData.uploadedFiles.filter(function(file) {
                return file.file_key !== fileKey;
            });
        },

        "handleCollapseAriaAtt": function(expandedRowEl) {
            var expandedDropdownId = expandedRowEl.data().partsDropdownId,
                $subpartRowEl = $('#' + expandedDropdownId),
                $subpartCopyBtn = $subpartRowEl.find('.subpart-table__btn--guid');

            expandedRowEl.removeClass('admin-search-results-parts--expanded');

            $("button[data-parts-dropdown-id='" + expandedDropdownId + "']").attr('aria-expanded', false);
            $subpartRowEl.attr('tabindex', '-1');
            $subpartCopyBtn.attr('tabindex', '-1');
        },

        "handleExpandAriaAtt": function(productRowEl) {
            var productDropdownId = productRowEl.data().partsDropdownId,
                $subpartRowEl = $('#' + productDropdownId),
                $subpartCopyBtn = $subpartRowEl.find('.subpart-table__btn--guid');

            productRowEl.addClass('admin-search-results-parts--expanded');

            $("button[data-parts-dropdown-id='" + productDropdownId + "']").attr('aria-expanded', true);
            $subpartRowEl.attr('tabindex', '0');
            $subpartCopyBtn.attr('tabindex', '0');
        },

        "toggleProductDisplayNameDropdown": function(event) {
            var $toggleProductPartDropdownBtn = $(event.target),
                $expandedAccordion = $('.admin-search-results-parts--expanded'),
                $productRowEl = $toggleProductPartDropdownBtn.closest('.admin-search-results-parts'),
                selectedHasExpandedClass = $productRowEl.hasClass('admin-search-results-parts--expanded');

            if ($expandedAccordion.length) {
                selectedHasExpandedClass ? this.handleCollapseAriaAtt($productRowEl) : this.handleCollapseAriaAtt($expandedAccordion);
            }

            if (!selectedHasExpandedClass) {
                this.handleExpandAriaAtt($productRowEl);
            }
        },

        "productPartGuidCopy": function(event) {
            var $copyBtn = $(event.target),
                partGuid = $copyBtn.data().partGuid,
                $toolTip = $copyBtn.siblings('.nebula-tooltip').find('.nebula-tooltip__tooltip');

            navigator.clipboard.writeText(partGuid);
            $toolTip.toggle();

            setTimeout(function() {
                $toolTip.toggle();
            }, 2000);
        },

        "onBeforeDestroy": function() {
            if (this.assetExclusionsVue) {
                this.assetExclusionsVue.unmount();
            }

            if (this.GLQVue) {
                this.GLQVue.unmount();
            }
        },
    });
});

